import {
  IMultiformCommunityDictionary,
  IMultiformDictionary,
  IMultiformDistrictDictionary,
  IMultiformNationalityDictionary
} from '@/modules/multiForm/shared/IMultiformDictionary';
import {CountryCode} from 'libphonenumber-js';
import {PersonalIdEnum} from '@/modules/client/enums/PersonalIdEnum';
import {IncomeDeliveredOn} from '@/modules/multiForm/shared/MultiformModels';
import {OrganisationId} from '@/models/enums/OrganisationId';
import {PartnerType} from '@/modules/partner/enums/PartnerType';
import {MarketType} from '@/models/simulation/MarketType';
import {LoanPurposeWhat} from '@/models/simulation/LoanPurposeWhat';
import {RoleTypes} from '@/commons/enums/RoleTypes';
import {RoleTypeNames} from '@/commons/enums/RoleTypeNames';
import {LoanPurposeActivity} from '@/models/simulation/LoanPurposeActivity';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import EnvironmentService from '@/env/EnvironmentService';
import {DisabilityState} from '@/commons/enums/DisabilityState';
import {FirstOrSubsequentRealEstate} from '@/models/simulation/FirstOrSubsequentRealEstate';
import {Gender} from '@/models/enums/Gender';
import {
  AssetType,
  CivilStatus,
  CompanyType,
  EducationDegree,
  FFCivilStatus,
  FFIncomeType,
  HomeStatus,
  IncomeFormType,
  IncomeType,
  LiabilityType,
  LimitType,
  PersonalSharesSourceType,
  Profession, RealEstateRights,
  RealEstateType,
  TaxType
} from '@/modules/multiForm/shared/Types';

const appDomainConfig = EnvironmentService.Environment.getAppDomainConfig();

export const separationCapitalDictionary: IMultiformDictionary<boolean | string> = [
  { name_pl: I18NGetter().useSeparationCapitalDictionary.YES, type: true, },
  { name_pl: I18NGetter().useSeparationCapitalDictionary.NO, type: false, },
  { name_pl: I18NGetter().useSeparationCapitalDictionary.NOT_APPLICABLE, type: 'Disabled', },
];

export const ffCivilStatusDictionary: IMultiformDictionary<FFCivilStatus> = [
  { name_pl: I18NGetter().useCivilStatusDictionary.SINGLE, type: FFCivilStatus.SINGLE, },
  {
    name_pl: I18NGetter().useCivilStatusDictionary.MARRIED_WITHOUT_SEPARATION_CAPITAL,
    type: FFCivilStatus.MARRIED_WITHOUT_SEPARATION_CAPITAL,
  },
  {
    name_pl: I18NGetter().useCivilStatusDictionary.MARRIED_WITH_SEPARATION_CAPITAL,
    type: FFCivilStatus.MARRIED_WITH_SEPARATION_CAPITAL,
  },
  { name_pl: I18NGetter().useCivilStatusDictionary.WIDOW, type: FFCivilStatus.WIDOW, },
  { name_pl: I18NGetter().useCivilStatusDictionary.PARTNERSHIP, type: FFCivilStatus.PARTNERSHIP, },
  { name_pl: I18NGetter().useCivilStatusDictionary.AFTER_MARRIAGE, type: FFCivilStatus.AFTER_MARRIGE, },
  { name_pl: I18NGetter().useCivilStatusDictionary.SEPARATION, type: FFCivilStatus.SEPARATION, },
];

export const civilStatusDictionary: IMultiformDictionary<CivilStatus> = [
  { name_pl: I18NGetter().useCivilStatusDictionary.SINGLE, type: CivilStatus.SINGLE, },
  { name_pl: I18NGetter().useCivilStatusDictionary.MARRIED, type: CivilStatus.MARRIED, },
  { name_pl: I18NGetter().useCivilStatusDictionary.WIDOW, type: CivilStatus.WIDOW, },
  { name_pl: I18NGetter().useCivilStatusDictionary.PARTNERSHIP, type: CivilStatus.PARTNERSHIP, },
  { name_pl: I18NGetter().useCivilStatusDictionary.AFTER_MARRIAGE, type: CivilStatus.AFTER_MARRIGE, },
  { name_pl: I18NGetter().useCivilStatusDictionary.SEPARATION, type: CivilStatus.SEPARATION, },
];

export const administrationProfessions: IMultiformDictionary<Profession> = [{
  name_pl: I18NGetter().useAdministrationProfessions.CIVIL_SERVANT, type: Profession.CIVIL_SERVANT,
},];
export const financeProfessions: IMultiformDictionary<Profession> = [
  {
    name_pl: I18NGetter().useFinanceProfessions.BROKER,
    type: Profession.BROKER,
  },
  {
    name_pl: I18NGetter().useFinanceProfessions.FINANCIAL_ADVISOR,
    type: Profession.FINANCIAL_ADVISOR,
  },
  {
    name_pl: I18NGetter().useFinanceProfessions.FINANCIAL_BROKER,
    type: Profession.FINANCIAL_BROKER,
  },
  {
    name_pl: I18NGetter().useFinanceProfessions.INSURANCE_SPECIALIST,
    type: Profession.INSURANCE_SPECIALIST,
  },
  {
    name_pl: I18NGetter().useFinanceProfessions.ANOTHER_FINANCIAL_SECTOR_EMPLOYEE,
    type: Profession.ANOTHER_FINANCIAL_SECTOR_EMPLOYEE,
  },
];
export const trustedProfessions: IMultiformDictionary<Profession> = [
  {
    type: Profession.LAWYER,
    name_pl: I18NGetter().useTrustedProfessions.LAWYER,
  },
  {
    type: Profession.ARCHITECT,
    name_pl: I18NGetter().useTrustedProfessions.ARCHITECT,
  },
  {
    type: Profession.AUDITOR,
    name_pl: I18NGetter().useTrustedProfessions.AUDITOR,
  },
  {
    type: Profession.APOTHECARY,
    name_pl: I18NGetter().useTrustedProfessions.APOTHECARY,
  },
  {
    type: Profession.CIVIL_ENGINEER,
    name_pl: I18NGetter().useTrustedProfessions.CIVIL_ENGINEER,
  },
  {
    type: Profession.BAILIFF,
    name_pl: I18NGetter().useTrustedProfessions.BAILIFF,
  },
  {
    type: Profession.ACCOUNTANT,
    name_pl: I18NGetter().useTrustedProfessions.ACCOUNTANT,
  },
  {
    type: Profession.DOCTOR,
    name_pl: I18NGetter().useTrustedProfessions.DOCTOR,
  },
  {
    type: Profession.NOTARY,
    name_pl: I18NGetter().useTrustedProfessions.NOTARY,
  },
  {
    type: Profession.NURSE,
    name_pl: I18NGetter().useTrustedProfessions.NURSE,
  },
  {
    type: Profession.SCIENTIST,
    name_pl: I18NGetter().useTrustedProfessions.SCIENTIST,
  },
  {
    type: Profession.PROSECUTOR,
    name_pl: I18NGetter().useTrustedProfessions.PROSECUTOR,
  },
  {
    type: Profession.LEGAL_COUNSEL,
    name_pl: I18NGetter().useTrustedProfessions.LEGAL_COUNSEL,
  },
  {
    type: Profession.PATENT_ATTORNEY,
    name_pl: I18NGetter().useTrustedProfessions.PATENT_ATTORNEY,
  },
  {
    type: Profession.REAL_ESTATE_APPRAISER,
    name_pl: I18NGetter().useTrustedProfessions.REAL_ESTATE_APPRAISER,
  },
  {
    type: Profession.JUDGE,
    name_pl: I18NGetter().useTrustedProfessions.JUDGE,
  },
  {
    type: Profession.TRANSLATOR,
    name_pl: I18NGetter().useTrustedProfessions.TRANSLATOR,
  },
  {
    type: Profession.VET,
    name_pl: I18NGetter().useTrustedProfessions.VET,
  },
];
export const otherProfessions: IMultiformDictionary<Profession> = [
  {
    name_pl: I18NGetter().useOtherProfessions.MANAGER,
    type: Profession.MANAGER,
  },
  {
    name_pl: I18NGetter().useOtherProfessions.UNIFORM_SERVICES,
    type: Profession.UNIFORM_SERVICES,
  },
  {
    name_pl: I18NGetter().useOtherProfessions.SAILOR,
    type: Profession.SAILOR,
  },
  {
    name_pl: I18NGetter().useOtherProfessions.TEACHER,
    type: Profession.TEACHER,
  },
  {
    name_pl: I18NGetter().useOtherProfessions.OTHER,
    type: Profession.OTHER,
  },
];

export const incomeTypesByFormType: Record<IncomeFormType, FFIncomeType[]> = {
  [IncomeFormType.DEFAULT_INCOME_TYPE_FORM]: [
    FFIncomeType.FLEX_TIME_CONTRACT,
    FFIncomeType.TIME_CONTRACT,
    FFIncomeType.CONTRACT_FOR_WORK_OR_ORDER,
    FFIncomeType.SEA_CONTRACT,
    FFIncomeType.MANAGER_CONTRACT,
    FFIncomeType.MILITARY_CONTRACT,
    FFIncomeType.INCOME_FROM_ABROAD_ACTIVITIES,
    FFIncomeType.INCOME_FROM_ABROAD_RETIRING,
    FFIncomeType.INCOME_FROM_ABROAD_PENSION,
    FFIncomeType.INCOME_FROM_ABROAD_FLEX_TIME_CONTRACT,
    FFIncomeType.INCOME_FROM_ABROAD_TIME_CONTRACT,
    FFIncomeType.PRIEST,
    FFIncomeType.MATTERNITY_LEAVE,
    FFIncomeType.APPOINTMENT,
    FFIncomeType.DRIVERS_DIET,
  ],
  [IncomeFormType.BUSINESS_INCOME_TYPE_FORM]: [
    FFIncomeType.GENERAL_ACTIVITIES,
    FFIncomeType.ACTIVITIES_FULL_ACCOUNTING,
    FFIncomeType.ACTIVITIES_FARMER,
  ],
  [IncomeFormType.BUSINESS_WITHOUT_COSTS_INCOME_TYPE_FORM]: [
    FFIncomeType.ACTIVITIES_3,
    FFIncomeType.ACTIVITIES_5,
    FFIncomeType.ACTIVITIES_8,
    FFIncomeType.ACTIVITIES_17_20,
    FFIncomeType.RENT_INCOME,
  ],
  [IncomeFormType.BON_CARD_INCOME_TYPE_FORM]: [
    FFIncomeType.ACTIVITIES_BON_CARD,
  ],
  [IncomeFormType.PERMANENT_INCOME_TYPE_FORM]: [
    FFIncomeType.INCOME_HOUSE_SUPLEMENT,
    FFIncomeType.INCOME_DIVIDENDS,
    FFIncomeType.RETIRING,
    FFIncomeType.PERMAMENT_PENSION,
  ],
  [IncomeFormType.RENT_INCOME_TYPE_FORM]: [
    FFIncomeType.RENT_INCOME,
  ],
  [IncomeFormType.GENERAL_ACTIVITIES_INCOME_TYPE_FORM]: [
    FFIncomeType.GENERAL_ACTIVITIES,
  ],
};

export const contractIncomeTypes: IMultiformDictionary<FFIncomeType> = [
  {
    name_pl: I18NGetter().useContractIncomeTypes.FLEX_TIME_CONTRACT,
    type: FFIncomeType.FLEX_TIME_CONTRACT,
  },
  {
    name_pl: I18NGetter().useContractIncomeTypes.TIME_CONTRACT,
    type: FFIncomeType.TIME_CONTRACT,
  },
  {
    name_pl: I18NGetter().useContractIncomeTypes.CONTRACT_FOR_WORK_OR_ORDER,
    type: FFIncomeType.CONTRACT_FOR_WORK_OR_ORDER,
  },
];
export const otherContractIncomeTypes: IMultiformDictionary<FFIncomeType> = [
  {
    name_pl: I18NGetter().useOtherContractIncomeTypes.SEA_CONTRACT,
    type: FFIncomeType.SEA_CONTRACT,
  },
  {
    name_pl: I18NGetter().useOtherContractIncomeTypes.MANAGER_CONTRACT,
    type: FFIncomeType.MANAGER_CONTRACT,
  },
  {
    name_pl: I18NGetter().useOtherContractIncomeTypes.MILITARY_CONTRACT,
    type: FFIncomeType.MILITARY_CONTRACT,
  },
];
export const businessIncomeTypes: IMultiformDictionary<FFIncomeType> = [
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.GENERAL_ACTIVITIES,
    type: FFIncomeType.GENERAL_ACTIVITIES,
  },
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.ACTIVITIES_3,
    type: FFIncomeType.ACTIVITIES_3,
  },
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.ACTIVITIES_5,
    type: FFIncomeType.ACTIVITIES_5,
  },
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.ACTIVITIES_8,
    type: FFIncomeType.ACTIVITIES_8,
  },
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.ACTIVITIES_17_20,
    type: FFIncomeType.ACTIVITIES_17_20,
  },
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.ACTIVITIES_BON_CARD,
    type: FFIncomeType.ACTIVITIES_BON_CARD,
  },
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.ACTIVITIES_FULL_ACCOUNTING,
    type: FFIncomeType.ACTIVITIES_FULL_ACCOUNTING,
  },
  {
    name_pl: I18NGetter().useBusinessIncomeTypes.ACTIVITIES_FARMER,
    type: FFIncomeType.ACTIVITIES_FARMER,
  },
].filter(item => !EnvironmentService.Environment
  .getAppDomainConfig().excludedMultiformItems.businessIncomeTypes?.includes(item.type));

export const abroadIncomeTypes: IMultiformDictionary<FFIncomeType> = [
  {
    name_pl: I18NGetter().useAbroadIncomeTypes.INCOME_FROM_ABROAD_TIME_CONTRACT,
    type: FFIncomeType.INCOME_FROM_ABROAD_TIME_CONTRACT,
  },
  {
    name_pl: I18NGetter().useAbroadIncomeTypes.INCOME_FROM_ABROAD_FLEX_TIME_CONTRACT,
    type: FFIncomeType.INCOME_FROM_ABROAD_FLEX_TIME_CONTRACT,
  },
  {
    name_pl: I18NGetter().useAbroadIncomeTypes.INCOME_FROM_ABROAD_ACTIVITIES,
    type: FFIncomeType.INCOME_FROM_ABROAD_ACTIVITIES,
  },
  {
    name_pl: I18NGetter().useAbroadIncomeTypes.INCOME_FROM_ABROAD_RETIRING,
    type: FFIncomeType.INCOME_FROM_ABROAD_RETIRING,
  },
  {
    name_pl: I18NGetter().useAbroadIncomeTypes.INCOME_FROM_ABROAD_PENSION,
    type: FFIncomeType.INCOME_FROM_ABROAD_PENSION,
  },
];
export const retirementIncomeTypes: IMultiformDictionary<FFIncomeType> = [
  {
    name_pl: I18NGetter().useRetirementIncomeTypes.PERMAMENT_PENSION,
    type: FFIncomeType.PERMAMENT_PENSION,
  },
  {
    name_pl: I18NGetter().useRetirementIncomeTypes.RETIRING,
    type: FFIncomeType.RETIRING,
  },
];
export const otherIncomeTypes: IMultiformDictionary<FFIncomeType> = [
  {
    name_pl: I18NGetter().useOtherIncomeTypes.PRIEST,
    type: FFIncomeType.PRIEST,
  },
  {
    name_pl: I18NGetter().useOtherIncomeTypes.RENT_INCOME,
    type: FFIncomeType.RENT_INCOME,
  },
  {
    name_pl: I18NGetter().useOtherIncomeTypes.MATTERNITY_LEAVE,
    type: FFIncomeType.MATTERNITY_LEAVE,
  },
  {
    name_pl: I18NGetter().useOtherIncomeTypes.DRIVERS_DIET,
    type: FFIncomeType.DRIVERS_DIET,
  },
  {
    name_pl: I18NGetter().useOtherIncomeTypes.INCOME_HOUSE_SUPLEMENT,
    type: FFIncomeType.INCOME_HOUSE_SUPLEMENT,
  },
  {
    name_pl: I18NGetter().useOtherIncomeTypes.INCOME_DIVIDENDS,
    type: FFIncomeType.INCOME_DIVIDENDS,
  },
  {
    name_pl: I18NGetter().useOtherIncomeTypes.APPOINTMENT,
    type: FFIncomeType.APPOINTMENT,
  },
].filter(item => !appDomainConfig.excludedMultiformItems.otherIncomeTypes?.includes(item.type));

export const nonBusinessIncomeTypesDictionary: IMultiformDictionary<FFIncomeType> = [
  ...contractIncomeTypes,
  ...otherContractIncomeTypes,
  ...abroadIncomeTypes,
  ...retirementIncomeTypes,
  ...otherIncomeTypes,
];

export const allIncomeTypesDictionary: IMultiformDictionary<FFIncomeType> = [
  ...nonBusinessIncomeTypesDictionary,
  ...businessIncomeTypes,
];

export const taxTypesDictionary: IMultiformDictionary<TaxType> = [
  {
    name_pl: I18NGetter().useTaxTypesDictionary.THRESHOLD_TAX,
    type: TaxType.THRESHOLD_TAX,
  },
  {
    name_pl: I18NGetter().useTaxTypesDictionary.LINEAR_TAX,
    type: TaxType.LINEAR_TAX,
  },
];

export const educationDictionary: IMultiformDictionary<EducationDegree> = [
  { name_pl: I18NGetter().useEducationDictionary.BASIC_NON_GRADUATE, type: EducationDegree.BASIC_NON_GRADUATE, },
  { name_pl: I18NGetter().useEducationDictionary.BASIC, type: EducationDegree.BASIC, },
  { name_pl: I18NGetter().useEducationDictionary.GYMNASIUM, type: EducationDegree.GYMNASIUM, },
  { name_pl: I18NGetter().useEducationDictionary.WORK_PREPARE, type: EducationDegree.WORK_PREPARE, },
  { name_pl: I18NGetter().useEducationDictionary.MEDIUM, type: EducationDegree.MEDIUM, },
  { name_pl: I18NGetter().useEducationDictionary.TECHNICAL, type: EducationDegree.TECHNICAL, },
  { name_pl: I18NGetter().useEducationDictionary.MEDIUM_AFTER, type: EducationDegree.MEDIUM_AFTER, },
  { name_pl: I18NGetter().useEducationDictionary.HIGHER_NON_GRADUATE, type: EducationDegree.HIGHER_NON_GRADUATE, },
  { name_pl: I18NGetter().useEducationDictionary.HIGHER, type: EducationDegree.HIGHER, },
  { name_pl: I18NGetter().useEducationDictionary.LICENSE, type: EducationDegree.LICENSE, },
  { name_pl: I18NGetter().useEducationDictionary.ENGINEER, type: EducationDegree.ENGINEER, },
  { name_pl: I18NGetter().useEducationDictionary.MASTER, type: EducationDegree.MASTER, },
  { name_pl: I18NGetter().useEducationDictionary.DOCTOR, type: EducationDegree.DOCTOR, },
  { name_pl: I18NGetter().useEducationDictionary.POST_GRADUATE, type: EducationDegree.POST_GRADUATE, },
  { name_pl: I18NGetter().useEducationDictionary.MBA, type: EducationDegree.MBA, },
];

export const homeStatusDictionary: IMultiformDictionary<HomeStatus> = [
  {
    name_pl: I18NGetter().useHomeStatusDictionary.HOUSE_OWNER_WITHOUT_MORTGAGE,
    type: HomeStatus.HOUSE_OWNER_WITHOUT_MORTGAGE,
  },
  {
    name_pl: I18NGetter().useHomeStatusDictionary.HOUSE_OWNER_WITH_MORTGAGE,
    type: HomeStatus.HOUSE_OWNER_WITH_MORTGAGE,
  },
  {
    name_pl: I18NGetter().useHomeStatusDictionary.FLAT_OWNER_WITHOUT_MORTGAGE,
    type: HomeStatus.FLAT_OWNER_WITHOUT_MORTGAGE,
  },
  {
    name_pl: I18NGetter().useHomeStatusDictionary.FLAT_OWNER_WITH_MORTGAGE,
    type: HomeStatus.FLAT_OWNER_WITH_MORTGAGE,
  },
  { name_pl: I18NGetter().useHomeStatusDictionary.WITH_FAMILY, type: HomeStatus.WITH_FAMILY, },
  { name_pl: I18NGetter().useHomeStatusDictionary.TENEMENT, type: HomeStatus.TENEMENT, },
  {
    name_pl: I18NGetter().useHomeStatusDictionary.CONDOMINIUM_WITHOUT_MORTGAGE,
    type: HomeStatus.CONDOMINIUM_WITHOUT_MORTGAGE,
  },
  {
    name_pl: I18NGetter().useHomeStatusDictionary.CONDOMINIUM_WITH_MORTGAGE,
    type: HomeStatus.CONDOMINIUM_WITH_MORTGAGE,
  },
  { name_pl: I18NGetter().useHomeStatusDictionary.TBS, type: HomeStatus.TBS, },
  { name_pl: I18NGetter().useHomeStatusDictionary.RENTAL_FLAT, type: HomeStatus.RENTAL_FLAT, },
  { name_pl: I18NGetter().useHomeStatusDictionary.RENTAL_HOUSE, type: HomeStatus.RENTAL_HOUSE, },
  { name_pl: I18NGetter().useHomeStatusDictionary.ACCOMODATION, type: HomeStatus.ACCOMODATION, },
  { name_pl: I18NGetter().useHomeStatusDictionary.WORK_FLAT, type: HomeStatus.WORK_FLAT, },
  { name_pl: I18NGetter().useHomeStatusDictionary.OTHER, type: HomeStatus.OTHER, },
];

export const liabilitiesDictionary: IMultiformDictionary<LiabilityType> = [
  { name_pl: I18NGetter().useLiabilitiesDictionary.MORTGAGE, type: LiabilityType.mortgage, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.MORTGAGE_LOAN, type: LiabilityType.mortgageLoan, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.CASH_LOAN, type: LiabilityType.cashLoan, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.CAR_LOAN, type: LiabilityType.carLoan, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.SHOP_LOAN, type: LiabilityType.shopLoan, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.INVEST_LOAN, type: LiabilityType.investLoan, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.FINANCIAL_LEASING, type: LiabilityType.financiaLeasing, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.LEASING, type: LiabilityType.leasing, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.BUSINESS_LOAN, type: LiabilityType.businessLoan, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.GUARANTE, type: LiabilityType.guarantee, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.BUSINESS_GUARANTEE, type: LiabilityType.businessGuarantee, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.ALIMONY, type: LiabilityType.alimony, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.RENT, type: LiabilityType.rent, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.BILL_OF_EXCHANGE, type: LiabilityType.billOfExchange, },
  { name_pl: I18NGetter().useLiabilitiesDictionary.INSURANCE, type: LiabilityType.insurance, },
].filter(item => !appDomainConfig
  .excludedMultiformItems.liabilityTypesDictionary?.includes(item.type));

export const limitsDictionary: IMultiformDictionary<LimitType> = [
  { name_pl: I18NGetter().useLimitsDictionary.CREDIT_CARD, type: LimitType.creditCard, },
  { name_pl: I18NGetter().useLimitsDictionary.BUSINESS_CREDIT_CARD, type: LimitType.businessCreditCard, },
  { name_pl: I18NGetter().useLimitsDictionary.ACCOUNT_LIMIT, type: LimitType.accountLimit, },
  { name_pl: I18NGetter().useLimitsDictionary.BUSINESS_ACCOUNT_LIMIT, type: LimitType.businessAccountLimit, },
];

export const marketTypesDictionary: IMultiformDictionary<MarketType> = [
  { name_pl: I18NGetter().useMarketTypesDictionary.SECONDARY_MARKET, type: MarketType.SECONDARY_MARKET,},
  { name_pl: I18NGetter().useMarketTypesDictionary.PRIMARY_MARKET, type: MarketType.PRIMARY_MARKET,},
];

export const firstOrSubsequentRealEstateDictionary: IMultiformDictionary<FirstOrSubsequentRealEstate> = [
  { name_pl: I18NGetter().useFirstOrSubsequentRealEstate.FIRST, type: FirstOrSubsequentRealEstate.FIRST,},
  { name_pl: I18NGetter().useFirstOrSubsequentRealEstate.SUBSEQUENT, type: FirstOrSubsequentRealEstate.SUBSEQUENT,},
];

export const loanPurposesDictionary: IMultiformDictionary<string> = [
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUYING_ON_PRIMARY, type: 'BuyingOnPrimary', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUYING_ON_PRIMARY_WITH_BUILDING, type: 'BuyingOnPrimaryWithBuilding', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUYING_ON_SECONDARY, type: 'BuyingOnSecondary', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUYING_PART_OF_REAL_ESTATE, type: 'BuyingPartOfRealEstate', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUILDING_SINGLE_FAMILY_HOUSE, type: 'BuildingSingleFamilyHouse', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUILDING_SINGLE_FAMILY_HOUSE_WITH_DEVELOPER, type: 'BuildingSingleFamilyHouseWithDeveloper', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUILDING_RECREATIONAL_HOUSE, type: 'BuildingRecreationalHouse', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.RENOVATING, type: 'Renovating', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.FINISHING, type: 'Finishing', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.FINISH_BUILDING, type: 'FinishBuilding', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.SUPERSTRUCTURE, type: 'Superstructure', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.EXTENDING, type: 'Extending', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.ADAPTATION, type: 'Adaptation', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REBUILDING_FOR_RESIDENTIAL_PURPOSES, type: 'RebuildingForResidentialPurposes', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.LOAN, type: 'Loan', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.BUYING_PLOT_AND_BUILDING, type: 'BuyingPlotAndBuilding', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REFINANCING_RESIDENTIAL_REAL_ESTATE, type: 'RefinancingResidentialRealEstate', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REFINANCING_NONRESIDENTIAL_REAL_ESTATE, type: 'RefinancingNonresidentialRealEstate', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REFINANCING_REAL_ESTATE_LOAN, type: 'RefinancingRealEstateLoan', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REFINANCING_NON_REAL_ESTATE_LOAN, type: 'RefinancingNonRealEstateLoan', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REFINANCING_RENOVATION, type: 'RefinancingRenovation', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.HOME_DEBT_CONSOLIDATION_LOAN, type: 'HomeDebtConsolidationLoan', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.CONSUMER_DEBT_CONSOLIDATION_LOAN, type: 'ConsumerDebtConsolidationLoan', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REPURCHASE_MUNICIPAL_FLAT, type: 'RepurchaseMunicipalFlat', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.REPURCHASE_FACTORY_FLAT, type: 'RepurchaseFactoryFlat', },
  {name_pl: I18NGetter().useLoanPurposesDictionary.ANY_PURPOSE, type: 'AnyPurpose', },
];

export const incomeTypesDictionary: IMultiformDictionary<IncomeType> = [
  {type: IncomeType.FLEX_TIME_CONTRACT, name_pl: I18NGetter().useIncomeTypesDictionary.FLEX_TIME_CONTRACT, },
  {type: IncomeType.TIME_CONTRACT, name_pl: I18NGetter().useIncomeTypesDictionary.TIME_CONTRACT, },
  {type: IncomeType.CONTRACT_FOR_ORDER, name_pl: I18NGetter().useIncomeTypesDictionary.CONTRACT_FOR_ORDER, },
  {type: IncomeType.CONTRACT_FOR_WORK, name_pl: I18NGetter().useIncomeTypesDictionary.CONTRACT_FOR_WORK, },
  {type: IncomeType.SEA_CONTRACT, name_pl: I18NGetter().useIncomeTypesDictionary.SEA_CONTRACT, },
  {type: 5, name_pl: I18NGetter().useIncomeTypesDictionary.MANAGER_CONTRACT, },
  {type: IncomeType.MILITARY_CONTRACT, name_pl: I18NGetter().useIncomeTypesDictionary.MILITARY_CONTRACT, },
  {type: IncomeType.GENERAL_ACTIVITIES, name_pl: I18NGetter().useIncomeTypesDictionary.GENERAL_ACTIVITIES, },
  {type: 7, name_pl: I18NGetter().useIncomeTypesDictionary.ACTIVITIES_3, },
  {type: 8, name_pl: I18NGetter().useIncomeTypesDictionary.ACTIVITIES_5, },
  {type: 9, name_pl: I18NGetter().useIncomeTypesDictionary.ACTIVITIES_8, },
  {type: 10, name_pl: I18NGetter().useIncomeTypesDictionary.ACTIVITIES_17_20, },
  {type: 11, name_pl: I18NGetter().useIncomeTypesDictionary.ACTIVITIES_BON_CARD, },
  {type: 12, name_pl: I18NGetter().useIncomeTypesDictionary.ACTIVITIES_FULL_ACCOUNTING, },
  {type: 13, name_pl: I18NGetter().useIncomeTypesDictionary.ACTIVITIES_FARMER, },
  {type: 14, name_pl: I18NGetter().useIncomeTypesDictionary.INCOME_FROM_ABROAD_ACTIVITIES, },
  {type: 15, name_pl: I18NGetter().useIncomeTypesDictionary.INCOME_FROM_ABROAD_RETIRING, },
  {type: 27, name_pl: I18NGetter().useIncomeTypesDictionary.INCOME_FROM_ABROAD_FLEX_TIME_CONTRACT, },
  {type: 28, name_pl: I18NGetter().useIncomeTypesDictionary.INCOME_FROM_ABROAD_TIME_CONTRACT, },
  {type: 16, name_pl: I18NGetter().useIncomeTypesDictionary.INCOME_FROM_ABROAD_PENSION, },
  {type: IncomeType.PERMAMENT_PENSION, name_pl: I18NGetter().useIncomeTypesDictionary.PERMANENT_PENSION, },
  {type: IncomeType.TERM_PENSION, name_pl: I18NGetter().useIncomeTypesDictionary.TERM_PENSION, },
  {type: IncomeType.STRUCTURAL_PENSION, name_pl: I18NGetter().useIncomeTypesDictionary.STRUCTURAL_PENSION, },
  {type: IncomeType.PRE_PENSION, name_pl: I18NGetter().useIncomeTypesDictionary.PRE_PENSION, },
  {type: IncomeType.SOCIAL_500, name_pl: I18NGetter().useIncomeTypesDictionary.SOCIAL_500, },
  {type: IncomeType.RETIRING, name_pl: I18NGetter().useIncomeTypesDictionary.RETIRING, },
  {type: IncomeType.PRIEST, name_pl: I18NGetter().useIncomeTypesDictionary.PRIEST, },
  {type: IncomeType.RENT_INCOME, name_pl: I18NGetter().useIncomeTypesDictionary.RENT_INCOME, },
  {type: IncomeType.MATTERNITY_LEAVE, name_pl: I18NGetter().useIncomeTypesDictionary.MATTERNITY_LEAVE, },
  {type: 22, name_pl: I18NGetter().useIncomeTypesDictionary.DRIVERS_DIET, },
  {type: 23, name_pl: I18NGetter().useIncomeTypesDictionary.INCOME_HOUSE_SUPLEMENT, },
  {type: 24, name_pl: I18NGetter().useIncomeTypesDictionary.INCOME_DIVIDENDS, },
  {type: 29, name_pl: I18NGetter().useIncomeTypesDictionary.APPOINTMENT, },
  {type: 95, name_pl: I18NGetter().useIncomeTypesDictionary.NO_INCOME, },
].filter(item => !appDomainConfig
  .excludedMultiformItems.incomeTypesDictionary?.includes(item.type));

export const genderDictionary: IMultiformDictionary<Gender> = [
  {type: Gender.MALE, name_pl: I18NGetter().useMultiFormDictionariesCalculatorForm.MALE, },
  {type: Gender.FEMALE, name_pl: I18NGetter().useMultiFormDictionariesCalculatorForm.FEMALE, },
];

export const industryDictionary: IMultiformDictionary<number> = [
  {name_pl: I18NGetter().useIndustryDictionary.PUBLIC_ADMINISTRATION_GOVERNMENT_INSTITUTIONS, type: 1, },
  {name_pl: I18NGetter().useIndustryDictionary.BANKING, type: 2, },
  {name_pl: I18NGetter().useIndustryDictionary.CONSTRUCTION, type: 4, },
  {name_pl: I18NGetter().useIndustryDictionary.CONSULTING, type: 5, },
  // {name_pl: 'Energetyka', type: 6, },
  // {name_pl: 'Przemysł wydobywczy/górnistwo', type: 7, },
  {name_pl: I18NGetter().useIndustryDictionary.TRADE_SALES, type: 8, },
  {name_pl: I18NGetter().useIndustryDictionary.METALLURGY, type: 12, },
  {name_pl: I18NGetter().useIndustryDictionary.IT, type: 39, },
  {name_pl: I18NGetter().useIndustryDictionary.OTHER_INDUSTRY, type: 13, },
  // {name_pl: I18NGetter().useIndustryDictionary.GOVERNMENT_INSTITUTIONS, type: 14, },
  {name_pl: I18NGetter().useIndustryDictionary.BAILIFFS, type: 15, },
  {name_pl: I18NGetter().useIndustryDictionary.MARKETING_ADVERTISING, type: 16, },
  {name_pl: I18NGetter().useIndustryDictionary.MASS_MEDIA, type: 17, },
  {name_pl: I18NGetter().useIndustryDictionary.SCIENCE_ED_CULTURE, type: 18, },
  {name_pl: I18NGetter().useIndustryDictionary.REAL_ESTATE_TRADING, type: 42, },
  {name_pl: I18NGetter().useIndustryDictionary.MANUFACTURING, type: 19, },
  {name_pl: I18NGetter().useIndustryDictionary.CHEMICAL_INDUSTRY, type: 20, },
  {name_pl: I18NGetter().useIndustryDictionary.ELECTRICAL_ELECTRONIC_INDUSTRY, type: 21, },
  {name_pl: I18NGetter().useIndustryDictionary.ENERGY, type: 22, },
  {name_pl: I18NGetter().useIndustryDictionary.MACHINERY, type: 23, },
  {name_pl: I18NGetter().useIndustryDictionary.BUILDING_MATERIALS, type: 24, },
  // {name_pl: I18NGetter().useIndustryDictionary.GARMENT, type: 25, },
  {name_pl: I18NGetter().useIndustryDictionary.PRECISION, type: 26, },
  {name_pl: I18NGetter().useIndustryDictionary.AUTOMOTIVE, type: 43, },
  {name_pl: I18NGetter().useIndustryDictionary.FOOD_PROCESSING, type: 27, },
  {name_pl: I18NGetter().useIndustryDictionary.MINING, type: 28, },
  {name_pl: I18NGetter().useIndustryDictionary.LIGHT_TEXTILES, type: 29, },
  {name_pl: I18NGetter().useIndustryDictionary.ACCOUNTING_AUDITING, type: 30, },
  {name_pl: I18NGetter().useIndustryDictionary.AGRICULTURE_FORESTRY, type: 31, },
  {name_pl: I18NGetter().useIndustryDictionary.CRAFTS, type: 32, },
  {name_pl: I18NGetter().useIndustryDictionary.HEALTHCARE, type: 33, },
  {name_pl: I18NGetter().useIndustryDictionary.UNIFORMED_SERVICES_POLICE_FIRE, type: 34, },
  {name_pl: I18NGetter().useIndustryDictionary.UNIFORMED_SERVICES_MILITARY, type: 41, },
  {name_pl: I18NGetter().useIndustryDictionary.TELECOMMUNICATIONS, type: 35, },
  {name_pl: I18NGetter().useIndustryDictionary.TRANSPORTATION_LOGISTICS, type: 36, },
  {name_pl: I18NGetter().useIndustryDictionary.TOURISM_HOSPITALITY, type: 37, },
  {name_pl: I18NGetter().useIndustryDictionary.INSURANCE, type: 3, },
  {name_pl: I18NGetter().useIndustryDictionary.SERVICES, type: 38, },
  {name_pl: I18NGetter().useIndustryDictionary.FINANCIAL_SERVICES, type: 40, },
  {name_pl: I18NGetter().useIndustryDictionary.LEGAL_SERVICES, type: 44, },
  {name_pl: I18NGetter().useIndustryDictionary.NGOS, type: 45, },
  {name_pl: I18NGetter().useIndustryDictionary.ENTERTAINMENT, type: 46, },
  {name_pl: I18NGetter().useIndustryDictionary.GASTRONOMY, type: 47, },
];

export const professionDictionary: IMultiformDictionary<number> = [
  {name_pl: I18NGetter().useProfessionDictionary.PHARMACIST, type: 4, },
  {name_pl: I18NGetter().useProfessionDictionary.DOCTOR, type: 2, },
  {name_pl: I18NGetter().useProfessionDictionary.MEDICAL_STAFF, type: 3, },
  {name_pl: I18NGetter().useProfessionDictionary.DENTIST, type: 116, },
  {name_pl: I18NGetter().useProfessionDictionary.VETERINARIAN, type: 5, },
  {name_pl: I18NGetter().useProfessionDictionary.INVESTMENT_ADVISOR, type: 17, },
  {name_pl: I18NGetter().useProfessionDictionary.FINANCIAL_INTERMEDIARY, type: 18, },
  {name_pl: I18NGetter().useProfessionDictionary.FINANCIAL_WORKER, type: 25, },
  {name_pl: I18NGetter().useProfessionDictionary.INSURANCE_COMPANY_EMPLOYEE, type: 30, },
  {name_pl: I18NGetter().useProfessionDictionary.LAWYER, type: 6, },
  {name_pl: I18NGetter().useProfessionDictionary.ARCHITECT, type: 11, },
  {name_pl: I18NGetter().useProfessionDictionary.CHARTERED_ACCOUNTANT, type: 10, },
  {name_pl: I18NGetter().useProfessionDictionary.TAX_ADVISOR, type: 14, },
  {name_pl: I18NGetter().useProfessionDictionary.CIVIL_ENGINEER, type: 12, },
  {name_pl: I18NGetter().useProfessionDictionary.BAILIFF, type: 15, },
  {name_pl: I18NGetter().useProfessionDictionary.ACCOUNTANT, type: 13, },
  {name_pl: I18NGetter().useProfessionDictionary.NOTARY_PUBLIC, type: 7, },
  {name_pl: I18NGetter().useProfessionDictionary.RESEARCHER, type: 19, },
  {name_pl: I18NGetter().useProfessionDictionary.LAWYER_CHECK, type: 110, },
  {name_pl: I18NGetter().useProfessionDictionary.PROSECUTOR, type: 9, },
  {name_pl: I18NGetter().useProfessionDictionary.LEGAL_ADVISOR, type: 24, },
  {name_pl: I18NGetter().useProfessionDictionary.PATENT_ATTORNEY, type: 28, },
  {name_pl: I18NGetter().useProfessionDictionary.JUDGE, type: 8, },
  {name_pl: I18NGetter().useProfessionDictionary.DIRECTOR, type: 100, },
  {name_pl: I18NGetter().useProfessionDictionary.MANAGER_MANAGER, type: 20, },
  {name_pl: I18NGetter().useProfessionDictionary.PRESIDENT, type: 101, },
  {name_pl: I18NGetter().useProfessionDictionary.MIDDLE_MANAGEMENT, type: 117, },
  {name_pl: I18NGetter().useProfessionDictionary.OWNER, type: 102, },
  {name_pl: I18NGetter().useProfessionDictionary.SENIOR_MANAGEMENT, type: 118, },
  {name_pl: I18NGetter().useProfessionDictionary.ARTIST, type: 121, },
  {name_pl: I18NGetter().useProfessionDictionary.CLERGY, type: 120, },
  {name_pl: I18NGetter().useProfessionDictionary.PENSIONER_CHECK, type: 106, },
  {name_pl: I18NGetter().useProfessionDictionary.HOUSEWIFE, type: 122, },
  {name_pl: I18NGetter().useProfessionDictionary.SAILOR, type: 22, },
  {name_pl: I18NGetter().useProfessionDictionary.TEACHER, type: 29, },
  {name_pl: I18NGetter().useProfessionDictionary.OTHER, type: 23, },
  {name_pl: I18NGetter().useProfessionDictionary.MANUAL_WORKER, type: 104, },
  {name_pl: I18NGetter().useProfessionDictionary.WHITE_COLLAR_WORKER, type: 105, },
  {name_pl: I18NGetter().useProfessionDictionary.SERVICE_WORKER, type: 109, },
  {name_pl: I18NGetter().useProfessionDictionary.ENTREPRENEUR, type: 111, },
  {name_pl: I18NGetter().useProfessionDictionary.PENSIONER, type: 107, },
  {name_pl: I18NGetter().useProfessionDictionary.INDUSTRIAL_WORKER, type: 112, },
  {name_pl: I18NGetter().useProfessionDictionary.FARMER_GARDENER_FISHERMAN, type: 113, },
  {name_pl: I18NGetter().useProfessionDictionary.REAL_ESTATE_APPRAISER, type: 27, },
  {name_pl: I18NGetter().useProfessionDictionary.UNIFORMED_SERVICE, type: 26, },
  {name_pl: I18NGetter().useProfessionDictionary.SPECIALIST_EXPERT, type: 103, },
  {name_pl: I18NGetter().useProfessionDictionary.LEGAL_PROFESSIONALS, type: 114, },
  {name_pl: I18NGetter().useProfessionDictionary.SALESMAN, type: 115, },
  {name_pl: I18NGetter().useProfessionDictionary.INTERN_TRAINEE, type: 108, },
  {name_pl: I18NGetter().useProfessionDictionary.STUDENT, type: 119, },
  {name_pl: I18NGetter().useProfessionDictionary.SWORN_TRANSLATOR, type: 16, },
  {name_pl: I18NGetter().useProfessionDictionary.CIVIL_SERVANT, type: 21, },
  {name_pl: I18NGetter().useProfessionDictionary.MINER, type: 123, },
  {name_pl: I18NGetter().useProfessionDictionary.RAILROADER, type: 124, },
  {name_pl: I18NGetter().useProfessionDictionary.MOUNTAIN_RESCUER, type: 125, },
  {name_pl: I18NGetter().useProfessionDictionary.PROFESSIONAL_DRIVER, type: 126, },
];

export const companyTypesDictionary: IMultiformDictionary<CompanyType> = [
  {
    type: CompanyType.WORK_IN_PUBLIC_OR_PRIVATE_ADMIN,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_PUBLIC_OR_PRIVATE_ADMIN,
  },
  {
    type: CompanyType.WORK_IN_PERSONAL_COMPANY,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_PERSONAL_COMPANY,
  },
  {
    type: CompanyType.WORK_IN_PUBLIC_COMPANY,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_PUBLIC_COMPANY,
  },
  {
    type: CompanyType.WORK_IN_LIMITED_COMPANY,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_LIMITED_COMPANY,
  },
  {
    type: CompanyType.WORK_IN_CIVIL_PARTNERSHIP,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_CIVIL_PARTNERSHIP,
  },
  {
    type: CompanyType.WORK_IN_GENERAL_PARTNERSHIP,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_GENERAL_PARTNERSHIP,
  },
  {
    type: CompanyType.WORK_IN_STATE_OWNED_COMPANY,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_STATE_OWNED_COMPANY,
  },
  {type: CompanyType.WORK_IN_ZOO, name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_ZOO, },
  {
    type: CompanyType.WORK_IN_OTHER_COMPANY_TYPE,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_OTHER_COMPANY_TYPE,
  },
  {type: CompanyType.WORK_IN_BUDGET_ZONE, name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_BUDGET_ZONE, },
  {type: CompanyType.WORK_IN_COOPERATIVE, name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_COOPERATIVE, },
  {
    type: CompanyType.WORK_IN_OTHER_WORKPLACE_TYPE,
    name_pl: I18NGetter().useCompanyTypesDictionary.WORK_IN_OTHER_WORKPLACE_TYPE,
  },
].filter(item => !appDomainConfig
  .excludedMultiformItems.companyTypesDictionary?.includes(item.type));

export const documentTypesDictionary: IMultiformDictionary<PersonalIdEnum> = [
  { name_pl: I18NGetter().useDocumentTypesDictionary.PERSONAL_ID, type: PersonalIdEnum.PERSONAL_ID, },
  { name_pl: I18NGetter().useDocumentTypesDictionary.PASSPORT, type: PersonalIdEnum.PASSPORT, },
  { name_pl: I18NGetter().useDocumentTypesDictionary.CITIZENSHIP_CARD, type: PersonalIdEnum.CITIZENSHIP_CARD, },
  { name_pl: I18NGetter().useDocumentTypesDictionary.DRIVER_LICENSE, type: PersonalIdEnum.DRIVER_LICENSE, },
  { name_pl: I18NGetter().useDocumentTypesDictionary.OTHER, type: PersonalIdEnum.OTHER, },
];

export const militaryServiceStatusDictionary: IMultiformDictionary<string> = [
  {name_pl: I18NGetter().useMilitaryServiceStatusDictionary.NOT_APPLICABLE, type: 'notApplicable', },
  {name_pl: I18NGetter().useMilitaryServiceStatusDictionary.REGULATED, type: 'regulated', },
  {name_pl: I18NGetter().useMilitaryServiceStatusDictionary.UNREGULATED, type: 'unregulated', },
  {name_pl: I18NGetter().useMilitaryServiceStatusDictionary.POSTPONED, type: 'postponed', },
];

export const borrowersRelationshipsDictionary: IMultiformDictionary<string> = [
  {name_pl: I18NGetter().useBorrowersRelationshipDictionary.MARRIAGE, type: 'marriage', },
  {name_pl: I18NGetter().useBorrowersRelationshipDictionary.PARENTS_AND_CHILDREN, type: 'parentsAndChildren', },
  {name_pl: I18NGetter().useBorrowersRelationshipDictionary.UNFORMAL_RELATION, type: 'unformalRelation', },
  {name_pl: I18NGetter().useBorrowersRelationshipDictionary.OTHER_FAMILY_MEMBERS, type: 'otherFamilyMembers', },
  {name_pl: I18NGetter().useBorrowersRelationshipDictionary.OTHER, type: 'other', },
];

export const loanPurposeWhatDictionary: IMultiformDictionary<RealEstateType> = [
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.APARTMENT, type: RealEstateType.APARTMENT, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.HOUSE, type: RealEstateType.HOUSE, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.MULTI_HOUSE, type: RealEstateType.MULTI_HOUSE, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.OFFICE, type: RealEstateType.OFFICE, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.HOLIDAY_HOME, type: RealEstateType.HOLIDAY_HOME, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.BUILDING_PLOT, type: RealEstateType.BUILDING_PLOT, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.RECREATION_PLOT, type: RealEstateType.RECREATION_PLOT, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.AGRICULTURAL_PLOT, type: RealEstateType.AGRICULTURAL_PLOT, },
  {
    name_pl: I18NGetter().useLoanPurposeWhatDictionary.RECREATION_PLOT_WITH_BUILDINGS,
    type: RealEstateType.RECREATION_PLOT_WITH_BUILDINGS,
  },
  {
    name_pl: I18NGetter().useLoanPurposeWhatDictionary.RECREATION_PLOT_WITHOUT_BUILDINGS,
    type: RealEstateType.RECREATION_PLOT_WITHOUT_BUILDINGS,
  },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.GARAGE, type: RealEstateType.GARAGE, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.CAR_PARKING, type: RealEstateType.CAR_PARKING, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.TENEMENT_HOUSE, type: RealEstateType.TENEMENT_HOUSE, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.SEGMENT, type: RealEstateType.SEGMENT, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.HABITATION, type: RealEstateType.HABITATION, },
  {name_pl: I18NGetter().useLoanPurposeWhatDictionary.STORAGE_ROOM, type: RealEstateType.STORAGE_ROOM, },
].filter(item => !EnvironmentService.Environment
  .getAppDomainConfig().excludedMultiformItems.loanPurposeWhatTypes?.includes(item.type));

export const loanPurposeRightsDictionary: IMultiformDictionary<RealEstateRights> = [
  {name_pl: I18NGetter().useLoanPurposeRightsDictionary.OWNERSHIP_RIGHT, type: RealEstateRights.OWNERSHIP_RIGHT, },
  {name_pl: I18NGetter().useLoanPurposeRightsDictionary.TENEMENT_RIGHT, type: RealEstateRights.TENEMENT_RIGHT, },
  {name_pl: I18NGetter().useLoanPurposeRightsDictionary.CONDOMINIUM_RIGHT, type: RealEstateRights.CONDOMINIUM_RIGHT, },
  {
    name_pl: I18NGetter().useLoanPurposeRightsDictionary.PERPETUAL_USUFRUCT,
    type: RealEstateRights.PERPETUAL_USUFRUCT,
  },
  {name_pl: I18NGetter().useLoanPurposeRightsDictionary.ASSET, type: RealEstateRights.ASSET, },
  {name_pl: I18NGetter().useLoanPurposeRightsDictionary.OTHER_RIGHT, type: RealEstateRights.OTHER_RIGHT, },
].filter(item => !EnvironmentService.Environment
  .getAppDomainConfig().excludedMultiformItems.loanPurposeRightsDictionary?.includes(item.type));

export const estateOwnerTypesDictionary: IMultiformDictionary<string> = [
  {name_pl: I18NGetter().useEstateOwnerTypes.DEVELOPER, type: 'developer', },
  {name_pl: I18NGetter().useEstateOwnerTypes.PERSON, type: 'person', },
  {name_pl: I18NGetter().useEstateOwnerTypes.HOUSING_ASSOCIATION, type: 'housingAssociation', },
  {name_pl: I18NGetter().useEstateOwnerTypes.TBS, type: 'tbs', },
];

export const estateConditionDictionary: IMultiformDictionary<number> = [
  { name_pl: I18NGetter().useEstateConditionDictionary.BAD, type: 1, },
  { name_pl: I18NGetter().useEstateConditionDictionary.MEDIUM, type: 2, },
  { name_pl: I18NGetter().useEstateConditionDictionary.GOOD, type: 3, },
  { name_pl: I18NGetter().useEstateConditionDictionary.VERY_GOOD, type: 4, },
];

export const finishingStandardDictionary: IMultiformDictionary<string> = [
  { name_pl: I18NGetter().useFinishingStandardDictionary.HIGH, type: 'high', },
  { name_pl: I18NGetter().useFinishingStandardDictionary.MEDIUM, type: 'medium', },
  { name_pl: I18NGetter().useFinishingStandardDictionary.LOW, type: 'low', },
  { name_pl: I18NGetter().useFinishingStandardDictionary.DEVELOPER_STATE, type: 'developerState', },
  { name_pl: I18NGetter().useFinishingStandardDictionary.FOR_RENOVATION, type: 'forRenovation', },
  { name_pl: I18NGetter().useFinishingStandardDictionary.FOR_FINISHING, type: 'forFinishing', },
  { name_pl: I18NGetter().useFinishingStandardDictionary.UNDER_KEY, type: 'underKey', },
];

export const buildingTypeDictionary: IMultiformDictionary<string> = [
  { name_pl: I18NGetter().useBuildingTypeDictionary.TWIN, type: 'twin', },
  { name_pl: I18NGetter().useBuildingTypeDictionary.HOUSE, type: 'house', },
  { name_pl: I18NGetter().useBuildingTypeDictionary.TERRACE_HOUSE, type: 'terraceHouse', },
  {name_pl: I18NGetter().useBuildingTypeDictionary.APARTMENT, type: 'apartment', },
  { name_pl: I18NGetter().useBuildingTypeDictionary.OTHER, type: 'other', },
];

export const constructionTypeDictionary: IMultiformDictionary<string> = [
  { name_pl: I18NGetter().useConstructionTypeDictionary.WOODEN, type: 'wooden', },
  { name_pl: I18NGetter().useConstructionTypeDictionary.MIX, type: 'mix', },
  { name_pl: I18NGetter().useConstructionTypeDictionary.BRICK, type: 'brick', },
  { name_pl: I18NGetter().useConstructionTypeDictionary.STEEL, type: 'steel', },
  { name_pl: I18NGetter().useConstructionTypeDictionary.REINFORCED_CONCRETE, type: 'reinforcedConcrete', },
];

export const garageCaseDictionary: IMultiformDictionary<string> = [
  { name_pl: I18NGetter().useGarageCaseDictionary.NONE_GARAGE, type: 'noneGarage', },
  { name_pl: I18NGetter().useGarageCaseDictionary.ONE_GARAGE_INSIDE, type: '1garageInside', },
  { name_pl: I18NGetter().useGarageCaseDictionary.TWO_GARAGE_INSIDE, type: '2garageInside', },
  { name_pl: I18NGetter().useGarageCaseDictionary.ONE_GARAGE_OUTSIDE, type: '1garageOutside', },
  { name_pl: I18NGetter().useGarageCaseDictionary.TWO_GARAGE_OUTSIDE, type: '2garageOutside', },
  { name_pl: I18NGetter().useGarageCaseDictionary.ONE_GARAGE_INSIDE_ONE_GARAGE_OUTSIDE, type: '1garageInside1garageOutside', },
];

export const sewersTypeDictionary: IMultiformDictionary<string> = [
  { name_pl: I18NGetter().useSewersTypeDictionary.OTHER, type: 'other', },
  { name_pl: I18NGetter().useSewersTypeDictionary.OWN, type: 'own', },
  { name_pl: I18NGetter().useSewersTypeDictionary.MUNCIPAL, type: 'municipal', },
];

export const waterIntakeDictionary: IMultiformDictionary<string> = [
  { name_pl: I18NGetter().useWaterIntakeDictionary.OTHER, type: 'other', },
  { name_pl: I18NGetter().useWaterIntakeDictionary.OWN, type: 'own', },
  { name_pl: I18NGetter().useWaterIntakeDictionary.MUNICIPAL, type: 'municipal', },
];

export const personalSharesTypeDictionary: IMultiformDictionary<string> = [
  {type: 'advance', name_pl: I18NGetter().usePersonalSharesTypeDictionary.ADVANCE, },
  {type: 'buildingPlotAsPersonalShare', name_pl: I18NGetter().usePersonalSharesTypeDictionary.BUILDING_PLOT_AS_PERSONAL_SHARE, },
  {type: 'creditedEstate', name_pl: I18NGetter().usePersonalSharesTypeDictionary.CREDITED_ESTATE, },
];

export const personalSharesDictionary: IMultiformDictionary<PersonalSharesSourceType> = [
  {type: PersonalSharesSourceType.BANK_ACCOUNTS, name_pl: I18NGetter().usePersonalSharesDictionary.BANK_ACCOUNTS, },
  {type: PersonalSharesSourceType.BANK_DEPOSITS, name_pl: I18NGetter().usePersonalSharesDictionary.BANK_DEPOSITS, },
  {
    type: PersonalSharesSourceType.HOUSING_BOOKLET,
    name_pl: I18NGetter().usePersonalSharesDictionary.HOUSING_BOOKLET,
  },
  {
    type: PersonalSharesSourceType.INVESTMENT_FUND,
    name_pl: I18NGetter().usePersonalSharesDictionary.INVESTMENT_FUND,
  },
  {type: PersonalSharesSourceType.PROPERTY_SALE, name_pl: I18NGetter().usePersonalSharesDictionary.PROPERTY_SALE, },
  {type: PersonalSharesSourceType.OTHER_SHARE, name_pl: I18NGetter().usePersonalSharesDictionary.OTHER_SHARE, },
];

export const assetTypesDictionary: IMultiformDictionary<AssetType> = [
  {type: AssetType.REALESTATE_APARTMENT, name_pl: I18NGetter().useAssetType.REALESTATE_APARTMENT, },
  {type: AssetType.REALESTATE_PLOT, name_pl: I18NGetter().useAssetType.REALESTATE_PLOT, },
  {type: AssetType.REALESTATE_HOUSE_ONE_FAMILY, name_pl: I18NGetter().useAssetType.REALESTATE_HOUSE_ONE_FAMILY, },
  {type: AssetType.REALESTATE_HOUSE_MULTI_FAMILY, name_pl: I18NGetter().useAssetType.REALESTATE_HOUSE_MULTI_FAMILY, },
  {type: AssetType.REALESTATE_OFFICE, name_pl: I18NGetter().useAssetType.REALESTATE_OFFICE, },
  {type: AssetType.SHARES, name_pl: I18NGetter().useAssetType.SHARES, },
  {type: AssetType.INVESTMENT, name_pl: I18NGetter().useAssetType.INVESTMENT, },
  {type: AssetType.FARMER_MACHINES, name_pl: I18NGetter().useAssetType.FARMER_MACHINES, },
  {type: AssetType.CAR, name_pl: I18NGetter().useAssetType.CAR, },
];

export const incomeDeliveredOnDictionary: IMultiformDictionary<string> = [
  {type: IncomeDeliveredOn.BANK_ACCOUNT, name_pl: I18NGetter().useIncomeDeliveredOnDictionary.BANK_ACCOUNT, },
  {type: IncomeDeliveredOn.CASH, name_pl: I18NGetter().useIncomeDeliveredOnDictionary.CASH, },
];

const countriesDictionary: IMultiformNationalityDictionary<CountryCode> = [
  {
    name_pl: I18NGetter().useCountriesDictionary.AFGHANISTAN,
    nationality: I18NGetter().useNationalitiesDictionary.AFGHANISTAN,
    type: 'AF',
    flag: 'https://restcountries.eu/data/afg.svg',
    callingCode: '93',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ALBANIA,
    nationality: I18NGetter().useNationalitiesDictionary.ALBANIA,
    type: 'AL',
    flag: 'https://restcountries.eu/data/alb.svg',
    callingCode: '355',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ALGERIA,
    nationality: I18NGetter().useNationalitiesDictionary.ALGERIA,
    type: 'DZ',
    flag: 'https://restcountries.eu/data/dza.svg',
    callingCode: '213',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ANDORRA,
    nationality: I18NGetter().useNationalitiesDictionary.ANDORRA,
    type: 'AD',
    flag: 'https://restcountries.eu/data/and.svg',
    callingCode: '376',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ANGOLA,
    nationality: I18NGetter().useNationalitiesDictionary.ANGOLA,
    type: 'AO',
    flag: 'https://restcountries.eu/data/ago.svg',
    callingCode: '244',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ANGUILLA,
    nationality: I18NGetter().useNationalitiesDictionary.ANGUILLA,
    type: 'AI',
    flag: 'https://restcountries.eu/data/aia.svg',
    callingCode: '1264',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ANTIGUA_AND_BARBUDA,
    nationality: I18NGetter().useNationalitiesDictionary.ANTIGUA_AND_BARBUDA,
    type: 'AG',
    flag: 'https://restcountries.eu/data/atg.svg',
    callingCode: '1268',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAUDI_ARABIA,
    nationality: I18NGetter().useNationalitiesDictionary.SAUDI_ARABIA,
    type: 'SA',
    flag: 'https://restcountries.eu/data/sau.svg',
    callingCode: '966',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ARGENTINA,
    nationality: I18NGetter().useNationalitiesDictionary.ARGENTINA,
    type: 'AR',
    flag: 'https://restcountries.eu/data/arg.svg',
    callingCode: '54',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ARMENIA,
    nationality: I18NGetter().useNationalitiesDictionary.ARMENIA,
    type: 'AM',
    flag: 'https://restcountries.eu/data/arm.svg',
    callingCode: '374',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ARUBA,
    nationality: I18NGetter().useNationalitiesDictionary.ARUBA,
    type: 'AW',
    flag: 'https://restcountries.eu/data/abw.svg',
    callingCode: '297',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.AUSTRALIA,
    nationality: I18NGetter().useNationalitiesDictionary.AUSTRALIA,
    type: 'AU',
    flag: 'https://restcountries.eu/data/aus.svg',
    callingCode: '61',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.AUSTRIA,
    nationality: I18NGetter().useNationalitiesDictionary.AUSTRIA,
    type: 'AT',
    flag: 'https://restcountries.eu/data/aut.svg',
    callingCode: '43',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.AZERBAIJAN,
    nationality: I18NGetter().useNationalitiesDictionary.AZERBAIJAN,
    type: 'AZ',
    flag: 'https://restcountries.eu/data/aze.svg',
    callingCode: '994',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BAHAMAS,
    nationality: I18NGetter().useNationalitiesDictionary.BAHAMAS,
    type: 'BS',
    flag: 'https://restcountries.eu/data/bhs.svg',
    callingCode: '1242',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BAHRAIN,
    nationality: I18NGetter().useNationalitiesDictionary.BAHRAIN,
    type: 'BH',
    flag: 'https://restcountries.eu/data/bhr.svg',
    callingCode: '973',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BANGLADESH,
    nationality: I18NGetter().useNationalitiesDictionary.BANGLADESH,
    type: 'BD',
    flag: 'https://restcountries.eu/data/bgd.svg',
    callingCode: '880',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BARBADOS,
    nationality: I18NGetter().useNationalitiesDictionary.BARBADOS,
    type: 'BB',
    flag: 'https://restcountries.eu/data/brb.svg',
    callingCode: '1246',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BELGIUM,
    nationality: I18NGetter().useNationalitiesDictionary.BELGIUM,
    type: 'BE',
    flag: 'https://restcountries.eu/data/bel.svg',
    callingCode: '32',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BELIZE,
    nationality: I18NGetter().useNationalitiesDictionary.BELIZE,
    type: 'BZ',
    flag: 'https://restcountries.eu/data/blz.svg',
    callingCode: '501',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BENIN,
    nationality: I18NGetter().useNationalitiesDictionary.BENIN,
    type: 'BJ',
    flag: 'https://restcountries.eu/data/ben.svg',
    callingCode: '229',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BERMUDA,
    nationality: I18NGetter().useNationalitiesDictionary.BERMUDA,
    type: 'BM',
    flag: 'https://restcountries.eu/data/bmu.svg',
    callingCode: '1441',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BHUTAN,
    nationality: I18NGetter().useNationalitiesDictionary.BHUTAN,
    type: 'BT',
    flag: 'https://restcountries.eu/data/btn.svg',
    callingCode: '975',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BELARUS,
    nationality: I18NGetter().useNationalitiesDictionary.BELARUS,
    type: 'BY',
    flag: 'https://restcountries.eu/data/blr.svg',
    callingCode: '375',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BOLIVIA,
    nationality: I18NGetter().useNationalitiesDictionary.BOLIVIA,
    type: 'BO',
    flag: 'https://restcountries.eu/data/bol.svg',
    callingCode: '591',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BONAIRE_SINT_EUSTATIUS_I_SABA,
    nationality: I18NGetter().useNationalitiesDictionary.BONAIRE_SINT_EUSTATIUS_I_SABA,
    type: 'BQ',
    flag: 'https://restcountries.eu/data/bes.svg',
    callingCode: '5997',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BOSNIA_AND_HERZEGOVINA,
    nationality: I18NGetter().useNationalitiesDictionary.BOSNIA_AND_HERZEGOVINA,
    type: 'BA',
    flag: 'https://restcountries.eu/data/bih.svg',
    callingCode: '387',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BOTSWANA,
    nationality: I18NGetter().useNationalitiesDictionary.BOTSWANA,
    type: 'BW',
    flag: 'https://restcountries.eu/data/bwa.svg',
    callingCode: '267',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BRAZIL,
    nationality: I18NGetter().useNationalitiesDictionary.BRAZIL,
    type: 'BR',
    flag: 'https://restcountries.eu/data/bra.svg',
    callingCode: '55',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BRUNEI,
    nationality: I18NGetter().useNationalitiesDictionary.BRUNEI,
    type: 'BN',
    flag: 'https://restcountries.eu/data/brn.svg',
    callingCode: '673',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BIOT,
    nationality: I18NGetter().useNationalitiesDictionary.BIOT,
    type: 'IO',
    flag: 'https://restcountries.eu/data/iot.svg',
    callingCode: '246',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BRITISH_VIRGIN_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.BRITISH_VIRGIN_ISLANDS,
    type: 'VG',
    flag: 'https://restcountries.eu/data/vgb.svg',
    callingCode: '1284',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BULGARIA,
    nationality: I18NGetter().useNationalitiesDictionary.BULGARIA,
    type: 'BG',
    flag: 'https://restcountries.eu/data/bgr.svg',
    callingCode: '359',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BURKINA_FASO,
    nationality: I18NGetter().useNationalitiesDictionary.BURKINA_FASO,
    type: 'BF',
    flag: 'https://restcountries.eu/data/bfa.svg',
    callingCode: '226',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.BURUNDI,
    nationality: I18NGetter().useNationalitiesDictionary.BURUNDI,
    type: 'BI',
    flag: 'https://restcountries.eu/data/bdi.svg',
    callingCode: '257',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CHILE,
    nationality: I18NGetter().useNationalitiesDictionary.CHILE,
    type: 'CL',
    flag: 'https://restcountries.eu/data/chl.svg',
    callingCode: '56',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CHINA,
    nationality: I18NGetter().useNationalitiesDictionary.CHINA,
    type: 'CN',
    flag: 'https://restcountries.eu/data/chn.svg',
    callingCode: '86',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CROATIA,
    nationality: I18NGetter().useNationalitiesDictionary.CROATIA,
    type: 'HR',
    flag: 'https://restcountries.eu/data/hrv.svg',
    callingCode: '385',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CURACAO,
    nationality: I18NGetter().useNationalitiesDictionary.CURACAO,
    type: 'CW',
    flag: 'https://restcountries.eu/data/cuw.svg',
    callingCode: '599',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CYPRUS,
    nationality: I18NGetter().useNationalitiesDictionary.CYPRUS,
    type: 'CY',
    flag: 'https://restcountries.eu/data/cyp.svg',
    callingCode: '357',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CHAD,
    nationality: I18NGetter().useNationalitiesDictionary.CHAD,
    type: 'TD',
    flag: 'https://restcountries.eu/data/tcd.svg',
    callingCode: '235',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MONTENEGRO,
    nationality: I18NGetter().useNationalitiesDictionary.MONTENEGRO,
    type: 'ME',
    flag: 'https://restcountries.eu/data/mne.svg',
    callingCode: '382',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CZECH_REPUBLIC,
    nationality: I18NGetter().useNationalitiesDictionary.CZECH_REPUBLIC,
    type: 'CZ',
    flag: 'https://restcountries.eu/data/cze.svg',
    callingCode: '420',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.DENMARK,
    nationality: I18NGetter().useNationalitiesDictionary.DENMARK,
    type: 'DK',
    flag: 'https://restcountries.eu/data/dnk.svg',
    callingCode: '45',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.DEMOCRATIC_REPUBLIC_OF_THE_CONGO,
    nationality: I18NGetter().useNationalitiesDictionary.DEMOCRATIC_REPUBLIC_OF_THE_CONGO,
    type: 'CD',
    flag: 'https://restcountries.eu/data/cod.svg',
    callingCode: '243',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.DOMINICA,
    nationality: I18NGetter().useNationalitiesDictionary.DOMINICA,
    type: 'DM',
    flag: 'https://restcountries.eu/data/dma.svg',
    callingCode: '1767',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.DOMINICAN_REPUBLIC,
    nationality: I18NGetter().useNationalitiesDictionary.DOMINICAN_REPUBLIC,
    type: 'DO',
    flag: 'https://restcountries.eu/data/dom.svg',
    callingCode: '1809',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.DJIBOUTI,
    nationality: I18NGetter().useNationalitiesDictionary.DJIBOUTI,
    type: 'DJ',
    flag: 'https://restcountries.eu/data/dji.svg',
    callingCode: '253',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.EGYPT,
    nationality: I18NGetter().useNationalitiesDictionary.EGYPT,
    type: 'EG',
    flag: 'https://restcountries.eu/data/egy.svg',
    callingCode: '20',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ECUADOR,
    nationality: I18NGetter().useNationalitiesDictionary.ECUADOR,
    type: 'EC',
    flag: 'https://restcountries.eu/data/ecu.svg',
    callingCode: '593',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ERITREA,
    nationality: I18NGetter().useNationalitiesDictionary.ERITREA,
    type: 'ER',
    flag: 'https://restcountries.eu/data/eri.svg',
    callingCode: '291',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ESTONIA,
    nationality: I18NGetter().useNationalitiesDictionary.ESTONIA,
    type: 'EE',
    flag: 'https://restcountries.eu/data/est.svg',
    callingCode: '372',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ETHIOPIA,
    nationality: I18NGetter().useNationalitiesDictionary.ETHIOPIA,
    type: 'ET',
    flag: 'https://restcountries.eu/data/eth.svg',
    callingCode: '251',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.FALKLAND_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.FALKLAND_ISLANDS,
    type: 'FK',
    flag: 'https://restcountries.eu/data/flk.svg',
    callingCode: '500',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.FIJI,
    nationality: I18NGetter().useNationalitiesDictionary.FIJI,
    type: 'FJ',
    flag: 'https://restcountries.eu/data/fji.svg',
    callingCode: '679',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PHILIPPINES,
    nationality: I18NGetter().useNationalitiesDictionary.PHILIPPINES,
    type: 'PH',
    flag: 'https://restcountries.eu/data/phl.svg',
    callingCode: '63',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.FINLAND,
    nationality: I18NGetter().useNationalitiesDictionary.FINLAND,
    type: 'FI',
    flag: 'https://restcountries.eu/data/fin.svg',
    callingCode: '358',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.FRANCE,
    nationality: I18NGetter().useNationalitiesDictionary.FRANCE,
    type: 'FR',
    flag: 'https://restcountries.eu/data/fra.svg',
    callingCode: '33',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GABON,
    nationality: I18NGetter().useNationalitiesDictionary.GABON,
    type: 'GA',
    flag: 'https://restcountries.eu/data/gab.svg',
    callingCode: '241',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GAMBIA,
    nationality: I18NGetter().useNationalitiesDictionary.GAMBIA,
    type: 'GM',
    flag: 'https://restcountries.eu/data/gmb.svg',
    callingCode: '220',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GHANA,
    nationality: I18NGetter().useNationalitiesDictionary.GHANA,
    type: 'GH',
    flag: 'https://restcountries.eu/data/gha.svg',
    callingCode: '233',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GIBRALTAR,
    nationality: I18NGetter().useNationalitiesDictionary.GIBRALTAR,
    type: 'GI',
    flag: 'https://restcountries.eu/data/gib.svg',
    callingCode: '350',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GREECE,
    nationality: I18NGetter().useNationalitiesDictionary.GREECE,
    type: 'GR',
    flag: 'https://restcountries.eu/data/grc.svg',
    callingCode: '30',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GRENADA,
    nationality: I18NGetter().useNationalitiesDictionary.GRENADA,
    type: 'GD',
    flag: 'https://restcountries.eu/data/grd.svg',
    callingCode: '1473',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GREENLAND,
    nationality: I18NGetter().useNationalitiesDictionary.GREENLAND,
    type: 'GL',
    flag: 'https://restcountries.eu/data/grl.svg',
    callingCode: '299',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GEORGIA,
    nationality: I18NGetter().useNationalitiesDictionary.GEORGIA,
    type: 'GE',
    flag: 'https://restcountries.eu/data/geo.svg',
    callingCode: '995',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GUAM,
    nationality: I18NGetter().useNationalitiesDictionary.GUAM,
    type: 'GU',
    flag: 'https://restcountries.eu/data/gum.svg',
    callingCode: '1671',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GUERNSEY,
    nationality: I18NGetter().useNationalitiesDictionary.GUERNSEY,
    type: 'GG',
    flag: 'https://restcountries.eu/data/ggy.svg',
    callingCode: '44',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.FRENCH_GUIANA,
    nationality: I18NGetter().useNationalitiesDictionary.FRENCH_GUIANA,
    type: 'GF',
    flag: 'https://restcountries.eu/data/guf.svg',
    callingCode: '594',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GUYANA,
    nationality: I18NGetter().useNationalitiesDictionary.GUYANA,
    type: 'GY',
    flag: 'https://restcountries.eu/data/guy.svg',
    callingCode: '592',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GUADELOUPE,
    nationality: I18NGetter().useNationalitiesDictionary.GUADELOUPE,
    type: 'GP',
    flag: 'https://restcountries.eu/data/glp.svg',
    callingCode: '590',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GUATEMALA,
    nationality: I18NGetter().useNationalitiesDictionary.GUATEMALA,
    type: 'GT',
    flag: 'https://restcountries.eu/data/gtm.svg',
    callingCode: '502',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GUINEA_BISSAU,
    nationality: I18NGetter().useNationalitiesDictionary.GUINEA_BISSAU,
    type: 'GW',
    flag: 'https://restcountries.eu/data/gnb.svg',
    callingCode: '245',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.EQUATORIAL_GUINEA,
    nationality: I18NGetter().useNationalitiesDictionary.EQUATORIAL_GUINEA,
    type: 'GQ',
    flag: 'https://restcountries.eu/data/gnq.svg',
    callingCode: '240',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GUINEA,
    nationality: I18NGetter().useNationalitiesDictionary.GUINEA,
    type: 'GN',
    flag: 'https://restcountries.eu/data/gin.svg',
    callingCode: '224',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.HAITI,
    nationality: I18NGetter().useNationalitiesDictionary.HAITI,
    type: 'HT',
    flag: 'https://restcountries.eu/data/hti.svg',
    callingCode: '509',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SPAIN,
    nationality: I18NGetter().useNationalitiesDictionary.SPAIN,
    type: 'ES',
    flag: 'https://restcountries.eu/data/esp.svg',
    callingCode: '34',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NETHERLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.NETHERLANDS,
    type: 'NL',
    flag: 'https://restcountries.eu/data/nld.svg',
    callingCode: '31',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.HONDURAS,
    nationality: I18NGetter().useNationalitiesDictionary.HONDURAS,
    type: 'HN',
    flag: 'https://restcountries.eu/data/hnd.svg',
    callingCode: '504',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.HONG_KONG,
    nationality: I18NGetter().useNationalitiesDictionary.HONG_KONG,
    type: 'HK',
    flag: 'https://restcountries.eu/data/hkg.svg',
    callingCode: '852',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.INDIA,
    nationality: I18NGetter().useNationalitiesDictionary.INDIA,
    type: 'IN',
    flag: 'https://restcountries.eu/data/ind.svg',
    callingCode: '91',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.INDONESIA,
    nationality: I18NGetter().useNationalitiesDictionary.INDONESIA,
    type: 'ID',
    flag: 'https://restcountries.eu/data/idn.svg',
    callingCode: '62',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.IRAQ,
    nationality: I18NGetter().useNationalitiesDictionary.IRAQ,
    type: 'IQ',
    flag: 'https://restcountries.eu/data/irq.svg',
    callingCode: '964',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.IRAN,
    nationality: I18NGetter().useNationalitiesDictionary.IRAN,
    type: 'IR',
    flag: 'https://restcountries.eu/data/irn.svg',
    callingCode: '98',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.IRELAND,
    nationality: I18NGetter().useNationalitiesDictionary.IRELAND,
    type: 'IE',
    flag: 'https://restcountries.eu/data/irl.svg',
    callingCode: '353',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ICELAND,
    nationality: I18NGetter().useNationalitiesDictionary.ICELAND,
    type: 'IS',
    flag: 'https://restcountries.eu/data/isl.svg',
    callingCode: '354',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ISRAEL,
    nationality: I18NGetter().useNationalitiesDictionary.ISRAEL,
    type: 'IL',
    flag: 'https://restcountries.eu/data/isr.svg',
    callingCode: '972',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.JAMAICA,
    nationality: I18NGetter().useNationalitiesDictionary.JAMAICA,
    type: 'JM',
    flag: 'https://restcountries.eu/data/jam.svg',
    callingCode: '1876',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.JAPAN,
    nationality: I18NGetter().useNationalitiesDictionary.JAPAN,
    type: 'JP',
    flag: 'https://restcountries.eu/data/jpn.svg',
    callingCode: '81',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.YEMEN,
    nationality: I18NGetter().useNationalitiesDictionary.YEMEN,
    type: 'YE',
    flag: 'https://restcountries.eu/data/yem.svg',
    callingCode: '967',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.JERSEY,
    nationality: I18NGetter().useNationalitiesDictionary.JERSEY,
    type: 'JE',
    flag: 'https://restcountries.eu/data/jey.svg',
    callingCode: '44',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.JORDAN,
    nationality: I18NGetter().useNationalitiesDictionary.JORDAN,
    type: 'JO',
    flag: 'https://restcountries.eu/data/jor.svg',
    callingCode: '962',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CAYMAN_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.CAYMAN_ISLANDS,
    type: 'KY',
    flag: 'https://restcountries.eu/data/cym.svg',
    callingCode: '1345',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CAMBODIA,
    nationality: I18NGetter().useNationalitiesDictionary.CAMBODIA,
    type: 'KH',
    flag: 'https://restcountries.eu/data/khm.svg',
    callingCode: '855',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CAMEROON,
    nationality: I18NGetter().useNationalitiesDictionary.CAMEROON,
    type: 'CM',
    flag: 'https://restcountries.eu/data/cmr.svg',
    callingCode: '237',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CANADA,
    nationality: I18NGetter().useNationalitiesDictionary.CANADA,
    type: 'CA',
    flag: 'https://restcountries.eu/data/can.svg',
    callingCode: '1',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.QATAR,
    nationality: I18NGetter().useNationalitiesDictionary.QATAR,
    type: 'QA',
    flag: 'https://restcountries.eu/data/qat.svg',
    callingCode: '974',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.KAZAKHSTAN,
    nationality: I18NGetter().useNationalitiesDictionary.KAZAKHSTAN,
    type: 'KZ',
    flag: 'https://restcountries.eu/data/kaz.svg',
    callingCode: '76',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.KENYA,
    nationality: I18NGetter().useNationalitiesDictionary.KENYA,
    type: 'KE',
    flag: 'https://restcountries.eu/data/ken.svg',
    callingCode: '254',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.KYRGYZSTAN,
    nationality: I18NGetter().useNationalitiesDictionary.KYRGYZSTAN,
    type: 'KG',
    flag: 'https://restcountries.eu/data/kgz.svg',
    callingCode: '996',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.KIRIBATI,
    nationality: I18NGetter().useNationalitiesDictionary.KIRIBATI,
    type: 'KI',
    flag: 'https://restcountries.eu/data/kir.svg',
    callingCode: '686',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.COLOMBIA,
    nationality: I18NGetter().useNationalitiesDictionary.COLOMBIA,
    type: 'CO',
    flag: 'https://restcountries.eu/data/col.svg',
    callingCode: '57',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.COMOROS,
    nationality: I18NGetter().useNationalitiesDictionary.COMOROS,
    type: 'KM',
    flag: 'https://restcountries.eu/data/com.svg',
    callingCode: '269',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CONGO,
    nationality: I18NGetter().useNationalitiesDictionary.CONGO,
    type: 'CG',
    flag: 'https://restcountries.eu/data/cog.svg',
    callingCode: '242',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SOUTH_KOREA,
    nationality: I18NGetter().useNationalitiesDictionary.SOUTH_KOREA,
    type: 'KR',
    flag: 'https://restcountries.eu/data/kor.svg',
    callingCode: '82',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NORTH_KOREA,
    nationality: I18NGetter().useNationalitiesDictionary.NORTH_KOREA,
    type: 'KP',
    flag: 'https://restcountries.eu/data/prk.svg',
    callingCode: '850',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.COSTA_RICA,
    nationality: I18NGetter().useNationalitiesDictionary.COSTA_RICA,
    type: 'CR',
    flag: 'https://restcountries.eu/data/cri.svg',
    callingCode: '506',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CUBA,
    nationality: I18NGetter().useNationalitiesDictionary.CUBA,
    type: 'CU',
    flag: 'https://restcountries.eu/data/cub.svg',
    callingCode: '53',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.KUWAIT,
    nationality: I18NGetter().useNationalitiesDictionary.KUWAIT,
    type: 'KW',
    flag: 'https://restcountries.eu/data/kwt.svg',
    callingCode: '965',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LAOS,
    nationality: I18NGetter().useNationalitiesDictionary.LAOS,
    type: 'LA',
    flag: 'https://restcountries.eu/data/lao.svg',
    callingCode: '856',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LESOTHO,
    nationality: I18NGetter().useNationalitiesDictionary.LESOTHO,
    type: 'LS',
    flag: 'https://restcountries.eu/data/lso.svg',
    callingCode: '266',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LEBANON,
    nationality: I18NGetter().useNationalitiesDictionary.LEBANON,
    type: 'LB',
    flag: 'https://restcountries.eu/data/lbn.svg',
    callingCode: '961',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LIBERIA,
    nationality: I18NGetter().useNationalitiesDictionary.LIBERIA,
    type: 'LR',
    flag: 'https://restcountries.eu/data/lbr.svg',
    callingCode: '231',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LIBYA,
    nationality: I18NGetter().useNationalitiesDictionary.LIBYA,
    type: 'LY',
    flag: 'https://restcountries.eu/data/lby.svg',
    callingCode: '218',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LIECHTENSTEIN,
    nationality: I18NGetter().useNationalitiesDictionary.LIECHTENSTEIN,
    type: 'LI',
    flag: 'https://restcountries.eu/data/lie.svg',
    callingCode: '423',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LITHUANIA,
    nationality: I18NGetter().useNationalitiesDictionary.LITHUANIA,
    type: 'LT',
    flag: 'https://restcountries.eu/data/ltu.svg',
    callingCode: '370',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LUXEMBOURG,
    nationality: I18NGetter().useNationalitiesDictionary.LUXEMBOURG,
    type: 'LU',
    flag: 'https://restcountries.eu/data/lux.svg',
    callingCode: '352',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.LATVIA,
    nationality: I18NGetter().useNationalitiesDictionary.LATVIA,
    type: 'LV',
    flag: 'https://restcountries.eu/data/lva.svg',
    callingCode: '371',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MACEDONIA,
    nationality: I18NGetter().useNationalitiesDictionary.MACEDONIA,
    type: 'MK',
    flag: 'https://restcountries.eu/data/mkd.svg',
    callingCode: '389',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MADAGASCAR,
    nationality: I18NGetter().useNationalitiesDictionary.MADAGASCAR,
    type: 'MG',
    flag: 'https://restcountries.eu/data/mdg.svg',
    callingCode: '261',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MAYOTTE,
    nationality: I18NGetter().useNationalitiesDictionary.MAYOTTE,
    type: 'YT',
    flag: 'https://restcountries.eu/data/myt.svg',
    callingCode: '262',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MACAU,
    nationality: I18NGetter().useNationalitiesDictionary.MACAU,
    type: 'MO',
    flag: 'https://restcountries.eu/data/mac.svg',
    callingCode: '853',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MALAWI,
    nationality: I18NGetter().useNationalitiesDictionary.MALAWI,
    type: 'MW',
    flag: 'https://restcountries.eu/data/mwi.svg',
    callingCode: '265',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MALDIVES,
    nationality: I18NGetter().useNationalitiesDictionary.MALDIVES,
    type: 'MV',
    flag: 'https://restcountries.eu/data/mdv.svg',
    callingCode: '960',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MALAYSIA,
    nationality: I18NGetter().useNationalitiesDictionary.MALAYSIA,
    type: 'MY',
    flag: 'https://restcountries.eu/data/mys.svg',
    callingCode: '60',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MALI,
    nationality: I18NGetter().useNationalitiesDictionary.MALI,
    type: 'ML',
    flag: 'https://restcountries.eu/data/mli.svg',
    callingCode: '223',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MALTA,
    nationality: I18NGetter().useNationalitiesDictionary.MALTA,
    type: 'MT',
    flag: 'https://restcountries.eu/data/mlt.svg',
    callingCode: '356',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NORTHERN_MARIANA_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.NORTHERN_MARIANA_ISLANDS,
    type: 'MP',
    flag: 'https://restcountries.eu/data/mnp.svg',
    callingCode: '1670',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MOROCCO,
    nationality: I18NGetter().useNationalitiesDictionary.MOROCCO,
    type: 'MA',
    flag: 'https://restcountries.eu/data/mar.svg',
    callingCode: '212',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MARTINIQUE,
    nationality: I18NGetter().useNationalitiesDictionary.MARTINIQUE,
    type: 'MQ',
    flag: 'https://restcountries.eu/data/mtq.svg',
    callingCode: '596',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MAURITANIA,
    nationality: I18NGetter().useNationalitiesDictionary.MAURITANIA,
    type: 'MR',
    flag: 'https://restcountries.eu/data/mrt.svg',
    callingCode: '222',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MAURITIUS,
    nationality: I18NGetter().useNationalitiesDictionary.MAURITIUS,
    type: 'MU',
    flag: 'https://restcountries.eu/data/mus.svg',
    callingCode: '230',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MEXICO,
    nationality: I18NGetter().useNationalitiesDictionary.MEXICO,
    type: 'MX',
    flag: 'https://restcountries.eu/data/mex.svg',
    callingCode: '52',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MICRONESIA,
    nationality: I18NGetter().useNationalitiesDictionary.MICRONESIA,
    type: 'FM',
    flag: 'https://restcountries.eu/data/fsm.svg',
    callingCode: '691',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MYANMAR,
    nationality: I18NGetter().useNationalitiesDictionary.MYANMAR,
    type: 'MM',
    flag: 'https://restcountries.eu/data/mmr.svg',
    callingCode: '95',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MOLDOVA,
    nationality: I18NGetter().useNationalitiesDictionary.MOLDOVA,
    type: 'MD',
    flag: 'https://restcountries.eu/data/mda.svg',
    callingCode: '373',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MONACO,
    nationality: I18NGetter().useNationalitiesDictionary.MONACO,
    type: 'MC',
    flag: 'https://restcountries.eu/data/mco.svg',
    callingCode: '377',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MONGOLIA,
    nationality: I18NGetter().useNationalitiesDictionary.MONGOLIA,
    type: 'MN',
    flag: 'https://restcountries.eu/data/mng.svg',
    callingCode: '976',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MONTSERRAT,
    nationality: I18NGetter().useNationalitiesDictionary.MONTSERRAT,
    type: 'MS',
    flag: 'https://restcountries.eu/data/msr.svg',
    callingCode: '1664',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MOZAMBIQUE,
    nationality: I18NGetter().useNationalitiesDictionary.MOZAMBIQUE,
    type: 'MZ',
    flag: 'https://restcountries.eu/data/moz.svg',
    callingCode: '258',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NAMIBIA,
    nationality: I18NGetter().useNationalitiesDictionary.NAMIBIA,
    type: 'NA',
    flag: 'https://restcountries.eu/data/nam.svg',
    callingCode: '264',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NAURU,
    nationality: I18NGetter().useNationalitiesDictionary.NAURU,
    type: 'NR',
    flag: 'https://restcountries.eu/data/nru.svg',
    callingCode: '674',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NEPAL,
    nationality: I18NGetter().useNationalitiesDictionary.NEPAL,
    type: 'NP',
    flag: 'https://restcountries.eu/data/npl.svg',
    callingCode: '977',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.GERMANY,
    nationality: I18NGetter().useNationalitiesDictionary.GERMANY,
    type: 'DE',
    flag: 'https://restcountries.eu/data/deu.svg',
    callingCode: '49',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NIGER,
    nationality: I18NGetter().useNationalitiesDictionary.NIGER,
    type: 'NE',
    flag: 'https://restcountries.eu/data/ner.svg',
    callingCode: '227',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NIGERIA,
    nationality: I18NGetter().useNationalitiesDictionary.NIGERIA,
    type: 'NG',
    flag: 'https://restcountries.eu/data/nga.svg',
    callingCode: '234',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NICARAGUA,
    nationality: I18NGetter().useNationalitiesDictionary.NICARAGUA,
    type: 'NI',
    flag: 'https://restcountries.eu/data/nic.svg',
    callingCode: '505',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NIUE,
    nationality: I18NGetter().useNationalitiesDictionary.NIUE,
    type: 'NU',
    flag: 'https://restcountries.eu/data/niu.svg',
    callingCode: '683',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NORFOLK_ISLAND,
    nationality: I18NGetter().useNationalitiesDictionary.NORFOLK_ISLAND,
    type: 'NF',
    flag: 'https://restcountries.eu/data/nfk.svg',
    callingCode: '672',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NORWAY,
    nationality: I18NGetter().useNationalitiesDictionary.NORWAY,
    type: 'NO',
    flag: 'https://restcountries.eu/data/nor.svg',
    callingCode: '47',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NEW_CALEDONIA,
    nationality: I18NGetter().useNationalitiesDictionary.NEW_CALEDONIA,
    type: 'NC',
    flag: 'https://restcountries.eu/data/ncl.svg',
    callingCode: '687',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.NEW_ZEALAND,
    nationality: I18NGetter().useNationalitiesDictionary.NEW_ZEALAND,
    type: 'NZ',
    flag: 'https://restcountries.eu/data/nzl.svg',
    callingCode: '64',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.OMAN,
    nationality: I18NGetter().useNationalitiesDictionary.OMAN,
    type: 'OM',
    flag: 'https://restcountries.eu/data/omn.svg',
    callingCode: '968',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PAKISTAN,
    nationality: I18NGetter().useNationalitiesDictionary.PAKISTAN,
    type: 'PK',
    flag: 'https://restcountries.eu/data/pak.svg',
    callingCode: '92',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PALAU,
    nationality: I18NGetter().useNationalitiesDictionary.PALAU,
    type: 'PW',
    flag: 'https://restcountries.eu/data/plw.svg',
    callingCode: '680',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PALESTINE,
    nationality: I18NGetter().useNationalitiesDictionary.PALESTINE,
    type: 'PS',
    flag: 'https://restcountries.eu/data/pse.svg',
    callingCode: '970',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PANAMA,
    nationality: I18NGetter().useNationalitiesDictionary.PANAMA,
    type: 'PA',
    flag: 'https://restcountries.eu/data/pan.svg',
    callingCode: '507',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PAPUA_NEW_GUINEA,
    nationality: I18NGetter().useNationalitiesDictionary.PAPUA_NEW_GUINEA,
    type: 'PG',
    flag: 'https://restcountries.eu/data/png.svg',
    callingCode: '675',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PARAGUAY,
    nationality: I18NGetter().useNationalitiesDictionary.PARAGUAY,
    type: 'PY',
    flag: 'https://restcountries.eu/data/pry.svg',
    callingCode: '595',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PERU,
    nationality: I18NGetter().useNationalitiesDictionary.PERU,
    type: 'PE',
    flag: 'https://restcountries.eu/data/per.svg',
    callingCode: '51',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.FRENCH_POLYNESIA,
    nationality: I18NGetter().useNationalitiesDictionary.FRENCH_POLYNESIA,
    type: 'PF',
    flag: 'https://restcountries.eu/data/pyf.svg',
    callingCode: '689',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.POLAND,
    nationality: I18NGetter().useNationalitiesDictionary.POLAND,
    type: 'PL',
    flag: 'https://restcountries.eu/data/pol.svg',
    callingCode: '48',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PUERTO_RICO,
    nationality: I18NGetter().useNationalitiesDictionary.PUERTO_RICO,
    type: 'PR',
    flag: 'https://restcountries.eu/data/pri.svg',
    callingCode: '1787',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.PORTUGAL,
    nationality: I18NGetter().useNationalitiesDictionary.PORTUGAL,
    type: 'PT',
    flag: 'https://restcountries.eu/data/prt.svg',
    callingCode: '351',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SOUTH_AFRICA,
    nationality: I18NGetter().useNationalitiesDictionary.SOUTH_AFRICA,
    type: 'ZA',
    flag: 'https://restcountries.eu/data/zaf.svg',
    callingCode: '27',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CENTRAL_AFRICAN_REPUBLIC,
    nationality: I18NGetter().useNationalitiesDictionary.CENTRAL_AFRICAN_REPUBLIC,
    type: 'CF',
    flag: 'https://restcountries.eu/data/caf.svg',
    callingCode: '236',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CABO_VERDE,
    nationality: I18NGetter().useNationalitiesDictionary.CABO_VERDE,
    type: 'CV',
    flag: 'https://restcountries.eu/data/cpv.svg',
    callingCode: '238',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.REUNION,
    nationality: I18NGetter().useNationalitiesDictionary.REUNION,
    type: 'RE',
    flag: 'https://restcountries.eu/data/reu.svg',
    callingCode: '262',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.RUSSIA,
    nationality: I18NGetter().useNationalitiesDictionary.RUSSIA,
    type: 'RU',
    flag: 'https://restcountries.eu/data/rus.svg',
    callingCode: '7',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ROMANIA,
    nationality: I18NGetter().useNationalitiesDictionary.ROMANIA,
    type: 'RO',
    flag: 'https://restcountries.eu/data/rou.svg',
    callingCode: '40',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.RWANDA,
    nationality: I18NGetter().useNationalitiesDictionary.RWANDA,
    type: 'RW',
    flag: 'https://restcountries.eu/data/rwa.svg',
    callingCode: '250',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.WESTERN_SAHARA,
    nationality: I18NGetter().useNationalitiesDictionary.WESTERN_SAHARA,
    type: 'EH',
    flag: 'https://restcountries.eu/data/esh.svg',
    callingCode: '212',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAINT_KITTS_AND_NEVIS,
    nationality: I18NGetter().useNationalitiesDictionary.SAINT_KITTS_AND_NEVIS,
    type: 'KN',
    flag: 'https://restcountries.eu/data/kna.svg',
    callingCode: '1869',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAINT_LUCIA,
    nationality: 'Saint Lucia',
    type: 'LC',
    flag: 'https://restcountries.eu/data/lca.svg',
    callingCode: '1758',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAINT_VINCENT_AND_THE_GRENADINES,
    nationality: I18NGetter().useNationalitiesDictionary.SAINT_VINCENT_AND_THE_GRENADINES,
    type: 'VC',
    flag: 'https://restcountries.eu/data/vct.svg',
    callingCode: '1784',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAINT_BARTHELEMY,
    nationality: I18NGetter().useNationalitiesDictionary.SAINT_BARTHELEMY,
    type: 'BL',
    flag: 'https://restcountries.eu/data/blm.svg',
    callingCode: '590',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAINT_MARTIN,
    nationality: I18NGetter().useNationalitiesDictionary.SAINT_MARTIN,
    type: 'MF',
    flag: 'https://restcountries.eu/data/maf.svg',
    callingCode: '590',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAINT_PIERRE_AND_MIQUELON,
    nationality: I18NGetter().useNationalitiesDictionary.SAINT_PIERRE_AND_MIQUELON,
    type: 'PM',
    flag: 'https://restcountries.eu/data/spm.svg',
    callingCode: '508',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.EL_SALVADOR,
    nationality: I18NGetter().useNationalitiesDictionary.EL_SALVADOR,
    type: 'SV',
    flag: 'https://restcountries.eu/data/slv.svg',
    callingCode: '503',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.AMERICAN_SAMOA,
    nationality: I18NGetter().useNationalitiesDictionary.AMERICAN_SAMOA,
    type: 'AS',
    flag: 'https://restcountries.eu/data/asm.svg',
    callingCode: '1684',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAMOA,
    nationality: I18NGetter().useNationalitiesDictionary.SAMOA,
    type: 'WS',
    flag: 'https://restcountries.eu/data/wsm.svg',
    callingCode: '685',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAN_MARINO,
    nationality: I18NGetter().useNationalitiesDictionary.SAN_MARINO,
    type: 'SM',
    flag: 'https://restcountries.eu/data/smr.svg',
    callingCode: '378',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SENEGAL,
    nationality: I18NGetter().useNationalitiesDictionary.SENEGAL,
    type: 'SN',
    flag: 'https://restcountries.eu/data/sen.svg',
    callingCode: '221',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SERBIA,
    nationality: I18NGetter().useNationalitiesDictionary.SERBIA,
    type: 'RS',
    flag: 'https://restcountries.eu/data/srb.svg',
    callingCode: '381',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SEYCHELLES,
    nationality: I18NGetter().useNationalitiesDictionary.SEYCHELLES,
    type: 'SC',
    flag: 'https://restcountries.eu/data/syc.svg',
    callingCode: '248',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SIERRA_LEONE,
    nationality: I18NGetter().useNationalitiesDictionary.SIERRA_LEONE,
    type: 'SL',
    flag: 'https://restcountries.eu/data/sle.svg',
    callingCode: '232',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SINGAPORE,
    nationality: I18NGetter().useNationalitiesDictionary.SINGAPORE,
    type: 'SG',
    flag: 'https://restcountries.eu/data/sgp.svg',
    callingCode: '65',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SINT_MAARTEN,
    nationality: I18NGetter().useNationalitiesDictionary.SINT_MAARTEN,
    type: 'SX',
    flag: 'https://restcountries.eu/data/sxm.svg',
    callingCode: '1721',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SLOVAKIA,
    nationality: I18NGetter().useNationalitiesDictionary.SLOVAKIA,
    type: 'SK',
    flag: 'https://restcountries.eu/data/svk.svg',
    callingCode: '421',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SLOVENIA,
    nationality: I18NGetter().useNationalitiesDictionary.SLOVENIA,
    type: 'SI',
    flag: 'https://restcountries.eu/data/svn.svg',
    callingCode: '386',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SOMALIA,
    nationality: I18NGetter().useNationalitiesDictionary.SOMALIA,
    type: 'SO',
    flag: 'https://restcountries.eu/data/som.svg',
    callingCode: '252',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SRI_LANKA,
    nationality: I18NGetter().useNationalitiesDictionary.SRI_LANKA,
    type: 'LK',
    flag: 'https://restcountries.eu/data/lka.svg',
    callingCode: '94',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.UNITED_STATES,
    nationality: I18NGetter().useNationalitiesDictionary.UNITED_STATES,
    type: 'US',
    flag: 'https://restcountries.eu/data/usa.svg',
    callingCode: '1',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SWAZILAND,
    nationality: I18NGetter().useNationalitiesDictionary.SWAZILAND,
    type: 'SZ',
    flag: 'https://restcountries.eu/data/swz.svg',
    callingCode: '268',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SUDAN,
    nationality: I18NGetter().useNationalitiesDictionary.SUDAN,
    type: 'SD',
    flag: 'https://restcountries.eu/data/sdn.svg',
    callingCode: '249',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SOUTH_SUDAN,
    nationality: I18NGetter().useNationalitiesDictionary.SOUTH_SUDAN,
    type: 'SS',
    flag: 'https://restcountries.eu/data/ssd.svg',
    callingCode: '211',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SURINAME,
    nationality: I18NGetter().useNationalitiesDictionary.SURINAME,
    type: 'SR',
    flag: 'https://restcountries.eu/data/sur.svg',
    callingCode: '597',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SVALBARD_AND_JAN_MAYEN,
    nationality: I18NGetter().useNationalitiesDictionary.SVALBARD_AND_JAN_MAYEN,
    type: 'SJ',
    flag: 'https://restcountries.eu/data/sjm.svg',
    callingCode: '4779',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SYRIA,
    nationality: I18NGetter().useNationalitiesDictionary.SYRIA,
    type: 'SY',
    flag: 'https://restcountries.eu/data/syr.svg',
    callingCode: '963',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SWITZERLAND,
    nationality: I18NGetter().useNationalitiesDictionary.SWITZERLAND,
    type: 'CH',
    flag: 'https://restcountries.eu/data/che.svg',
    callingCode: '41',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SWEDEN,
    nationality: I18NGetter().useNationalitiesDictionary.SWEDEN,
    type: 'SE',
    flag: 'https://restcountries.eu/data/swe.svg',
    callingCode: '46',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TAJIKISTAN,
    nationality: I18NGetter().useNationalitiesDictionary.TAJIKISTAN,
    type: 'TJ',
    flag: 'https://restcountries.eu/data/tjk.svg',
    callingCode: '992',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.THAILAND,
    nationality: I18NGetter().useNationalitiesDictionary.THAILAND,
    type: 'TH',
    flag: 'https://restcountries.eu/data/tha.svg',
    callingCode: '66',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TAIWAN,
    nationality: I18NGetter().useNationalitiesDictionary.TAIWAN,
    type: 'TW',
    flag: 'https://restcountries.eu/data/twn.svg',
    callingCode: '886',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TANZANIA,
    nationality: I18NGetter().useNationalitiesDictionary.TANZANIA,
    type: 'TZ',
    flag: 'https://restcountries.eu/data/tza.svg',
    callingCode: '255',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TIMOR_LESTE,
    nationality: I18NGetter().useNationalitiesDictionary.TIMOR_LESTE,
    type: 'TL',
    flag: 'https://restcountries.eu/data/tls.svg',
    callingCode: '670',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TOGO,
    nationality: I18NGetter().useNationalitiesDictionary.TOGO,
    type: 'TG',
    flag: 'https://restcountries.eu/data/tgo.svg',
    callingCode: '228',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TOKELAU,
    nationality: I18NGetter().useNationalitiesDictionary.TOKELAU,
    type: 'TK',
    flag: 'https://restcountries.eu/data/tkl.svg',
    callingCode: '690',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TONGA,
    nationality: I18NGetter().useNationalitiesDictionary.TONGA,
    type: 'TO',
    flag: 'https://restcountries.eu/data/ton.svg',
    callingCode: '676',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TRINIDAD_AND_TOBAGO,
    nationality: I18NGetter().useNationalitiesDictionary.TRINIDAD_AND_TOBAGO,
    type: 'TT',
    flag: 'https://restcountries.eu/data/tto.svg',
    callingCode: '1868',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TUNISIA,
    nationality: I18NGetter().useNationalitiesDictionary.TUNISIA,
    type: 'TN',
    flag: 'https://restcountries.eu/data/tun.svg',
    callingCode: '216',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TURKEY,
    nationality: I18NGetter().useNationalitiesDictionary.TURKEY,
    type: 'TR',
    flag: 'https://restcountries.eu/data/tur.svg',
    callingCode: '90',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TURKMENISTAN,
    nationality: I18NGetter().useNationalitiesDictionary.TURKMENISTAN,
    type: 'TM',
    flag: 'https://restcountries.eu/data/tkm.svg',
    callingCode: '993',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TURKS_AND_CAICOS_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.TURKS_AND_CAICOS_ISLANDS,
    type: 'TC',
    flag: 'https://restcountries.eu/data/tca.svg',
    callingCode: '1649',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.TUVALU,
    nationality: I18NGetter().useNationalitiesDictionary.TUVALU,
    type: 'TV',
    flag: 'https://restcountries.eu/data/tuv.svg',
    callingCode: '688',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.UGANDA,
    nationality: I18NGetter().useNationalitiesDictionary.UGANDA,
    type: 'UG',
    flag: 'https://restcountries.eu/data/uga.svg',
    callingCode: '256',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.UKRAINE,
    nationality: I18NGetter().useNationalitiesDictionary.UKRAINE,
    type: 'UA',
    flag: 'https://restcountries.eu/data/ukr.svg',
    callingCode: '380',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.URUGUAY,
    nationality: I18NGetter().useNationalitiesDictionary.URUGUAY,
    type: 'UY',
    flag: 'https://restcountries.eu/data/ury.svg',
    callingCode: '598',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.UZBEKISTAN,
    nationality: I18NGetter().useNationalitiesDictionary.UZBEKISTAN,
    type: 'UZ',
    flag: 'https://restcountries.eu/data/uzb.svg',
    callingCode: '998',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.VANUATU,
    nationality: I18NGetter().useNationalitiesDictionary.VANUATU,
    type: 'VU',
    flag: 'https://restcountries.eu/data/vut.svg',
    callingCode: '678',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.WALLIS_AND_FUTUNA,
    nationality: I18NGetter().useNationalitiesDictionary.WALLIS_AND_FUTUNA,
    type: 'WF',
    flag: 'https://restcountries.eu/data/wlf.svg',
    callingCode: '681',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.VATICAN_CITY,
    nationality: I18NGetter().useNationalitiesDictionary.VATICAN_CITY,
    type: 'VA',
    flag: 'https://restcountries.eu/data/vat.svg',
    callingCode: '379',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.VENEZUELA,
    nationality: I18NGetter().useNationalitiesDictionary.VENEZUELA,
    type: 'VE',
    flag: 'https://restcountries.eu/data/ven.svg',
    callingCode: '58',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.HUNGARY,
    nationality: I18NGetter().useNationalitiesDictionary.HUNGARY,
    type: 'HU',
    flag: 'https://restcountries.eu/data/hun.svg',
    callingCode: '36',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.UNITED_KINGDOM,
    nationality: I18NGetter().useNationalitiesDictionary.UNITED_KINGDOM,
    type: 'GB',
    flag: 'https://restcountries.eu/data/gbr.svg',
    callingCode: '44',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.VIETNAM,
    nationality: I18NGetter().useNationalitiesDictionary.VIETNAM,
    type: 'VN',
    flag: 'https://restcountries.eu/data/vnm.svg',
    callingCode: '84',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ITALY,
    nationality: I18NGetter().useNationalitiesDictionary.ITALY,
    type: 'IT',
    flag: 'https://restcountries.eu/data/ita.svg',
    callingCode: '39',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.COTE_D_IVOIRE,
    nationality: I18NGetter().useNationalitiesDictionary.COTE_D_IVOIRE,
    type: 'CI',
    flag: 'https://restcountries.eu/data/civ.svg',
    callingCode: '225',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.CHRISTMAS_ISLAND,
    nationality: I18NGetter().useNationalitiesDictionary.CHRISTMAS_ISLAND,
    type: 'CX',
    flag: 'https://restcountries.eu/data/cxr.svg',
    callingCode: '61',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ISLE_OF_MAN,
    nationality: I18NGetter().useNationalitiesDictionary.ISLE_OF_MAN,
    type: 'IM',
    flag: 'https://restcountries.eu/data/imn.svg',
    callingCode: '44',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA,
    nationality: I18NGetter().useNationalitiesDictionary.SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA,
    type: 'SH',
    flag: 'https://restcountries.eu/data/shn.svg',
    callingCode: '290',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ALAND_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.ALAND_ISLANDS,
    type: 'AX',
    flag: 'https://restcountries.eu/data/ala.svg',
    callingCode: '358',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.COOK_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.COOK_ISLANDS,
    type: 'CK',
    flag: 'https://restcountries.eu/data/cok.svg',
    callingCode: '682',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.UNITED_STATES_VIRGIN_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.UNITED_STATES_VIRGIN_ISLANDS,
    type: 'VI',
    flag: 'https://restcountries.eu/data/vir.svg',
    callingCode: '1 340',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.COCOS_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.COCOS_ISLANDS,
    type: 'CC',
    flag: 'https://restcountries.eu/data/cck.svg',
    callingCode: '61',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.MARSHALL_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.MARSHALL_ISLANDS,
    type: 'MH',
    flag: 'https://restcountries.eu/data/mhl.svg',
    callingCode: '692',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.FAROE_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.FAROE_ISLANDS,
    type: 'FO',
    flag: 'https://restcountries.eu/data/fro.svg',
    callingCode: '298',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SOLOMON_ISLANDS,
    nationality: I18NGetter().useNationalitiesDictionary.SOLOMON_ISLANDS,
    type: 'SB',
    flag: 'https://restcountries.eu/data/slb.svg',
    callingCode: '677',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.SAO_TOME_AND_PRINCIPE,
    nationality: I18NGetter().useNationalitiesDictionary.SAO_TOME_AND_PRINCIPE,
    type: 'ST',
    flag: 'https://restcountries.eu/data/stp.svg',
    callingCode: '239',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ZAMBIA,
    nationality: I18NGetter().useNationalitiesDictionary.ZAMBIA,
    type: 'ZM',
    flag: 'https://restcountries.eu/data/zmb.svg',
    callingCode: '260',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.ZIMBABWE,
    nationality: I18NGetter().useNationalitiesDictionary.ZIMBABWE,
    type: 'ZW',
    flag: 'https://restcountries.eu/data/zwe.svg',
    callingCode: '263',
  }, {
    name_pl: I18NGetter().useCountriesDictionary.UNITED_ARAB_EMIRATES,
    nationality: I18NGetter().useNationalitiesDictionary.UNITED_ARAB_EMIRATES,
    type: 'AE',
    flag: 'https://restcountries.eu/data/are.svg',
    callingCode: '971',
  },
];

const defaultCountry = countriesDictionary.find((country) => country.type === appDomainConfig.region)!;
export const ekwDictionary: IMultiformDictionary<string> = [
  { type: 'WL1A', name_pl: 'ALEKSANDRÓW KUJAWSKI - WL1A', },
  { type: 'SU1A', name_pl: 'AUGUSTÓW - SU1A', },
  { type: 'OL1Y', name_pl: 'BARTOSZYCE - OL1Y', },
  { type: 'PT1B', name_pl: 'BEŁCHATÓW - PT1B', },
  { type: 'KA1B', name_pl: 'BĘDZIN - KA1B', },
  { type: 'LU1B', name_pl: 'BIAŁA PODLASKA - LU1B', },
  { type: 'RA2G', name_pl: 'BIAŁOBRZEGI - RA2G', },
  { type: 'KO1B', name_pl: 'BIAŁOGARD - KO1B', },
  { type: 'BI1B', name_pl: 'BIAŁYSTOK - BI1B', },
  { type: 'BB1B', name_pl: 'BIELSKO-BIAŁA - BB1B', },
  { type: 'BI1P', name_pl: 'BIELSK PODLASKI - BI1P', },
  { type: 'ZA1B', name_pl: 'BIŁGORAJ - ZA1B', },
  { type: 'OL1B', name_pl: 'BISKUPIEC - OL1B', },
  { type: 'TR1O', name_pl: 'BOCHNIA - TR1O', },
  { type: 'JG1B', name_pl: 'BOLESŁAWIEC - JG1B', },
  { type: 'EL1B', name_pl: 'BRANIEWO - EL1B', },
  { type: 'TO1B', name_pl: 'BRODNICA - TO1B', },
  { type: 'OP1B', name_pl: 'BRZEG - OP1B', },
  { type: 'TR1B', name_pl: 'BRZESKO - TR1B', },
  { type: 'LD1B', name_pl: 'BRZEZINY - LD1B', },
  { type: 'KS1B', name_pl: 'BRZOZÓW - KS1B', },
  { type: 'KI1B', name_pl: 'BUSKO ZDRÓJ - KI1B', },
  { type: 'BY1B', name_pl: 'BYDGOSZCZ - BY1B', },
  { type: 'KA1Y', name_pl: 'BYTOM - KA1Y', },
  { type: 'SL1B', name_pl: 'BYTÓW - SL1B', },
  { type: 'LU1C', name_pl: 'CHEŁM - LU1C', },
  { type: 'TO1C', name_pl: 'CHEŁMNO - TO1C', },
  { type: 'PO1H', name_pl: 'CHODZIEŻ - PO1H', },
  { type: 'SL1C', name_pl: 'CHOJNICE - SL1C', },
  { type: 'KA1C', name_pl: 'CHORZÓW - KA1C', },
  { type: 'SZ1C', name_pl: 'CHOSZCZNO - SZ1C', },
  { type: 'KR1C', name_pl: 'CHRZANÓW - KR1C', },
  { type: 'PL1C', name_pl: 'CIECHANÓW - PL1C', },
  { type: 'BB1C', name_pl: 'CIESZYN - BB1C', },
  { type: 'PO2T', name_pl: 'CZARNKÓW - PO2T', },
  { type: 'KR1K', name_pl: 'CZERNICHÓW - KR1K', },
  { type: 'CZ1C', name_pl: 'CZĘSTOCHOWA - CZ1C', },
  { type: 'SL1Z', name_pl: 'CZŁUCHÓW - SL1Z', },
  { type: 'KA1D', name_pl: 'DĄBROWA GÓRNICZA - KA1D', },
  { type: 'TR1D', name_pl: 'DĄBROWA TARNOWSKA - TR1D', },
  { type: 'RZ1D', name_pl: 'DĘBICA - RZ1D', },
  { type: 'KR2Y', name_pl: 'DOBCZYCE - KR2Y', },
  { type: 'KO1D', name_pl: 'DRAWSKO POMORSKIE - KO1D', },
  { type: 'EL1D', name_pl: 'DZIAŁDOWO - EL1D', },
  { type: 'SW1D', name_pl: 'DZIERŻONIÓW - SW1D', },
  { type: 'EL1E', name_pl: 'ELBLĄG - EL1E', },
  { type: 'OL1E', name_pl: 'EŁK - OL1E', },
  { type: 'SI1G', name_pl: 'GARWOLIN - SI1G', },
  { type: 'GD1G', name_pl: 'GDAŃSK - GD1G', },
  { type: 'GD1Y', name_pl: 'GDYNIA - GD1Y', },
  { type: 'OL1G', name_pl: 'GIŻYCKO - OL1G', },
  { type: 'GL1G', name_pl: 'GLIWICE - GL1G', },
  { type: 'LE1G', name_pl: 'GŁOGÓW - LE1G', },
  { type: 'OP1G', name_pl: 'GŁUBCZYCE - OP1G', },
  { type: 'PO1G', name_pl: 'GNIEZNO - PO1G', },
  { type: 'SZ1O', name_pl: 'GOLENIÓW - SZ1O', },
  { type: 'TO1G', name_pl: 'GOLUB-DOBRZYŃ - TO1G', },
  { type: 'NS1G', name_pl: 'GORLICE - NS1G', },
  { type: 'GW1G', name_pl: 'GORZÓW WIELKOPOLSKI - GW1G', },
  { type: 'PL1G', name_pl: 'GOSTYNIN - PL1G', },
  { type: 'PO1Y', name_pl: 'GOSTYŃ - PO1Y', },
  { type: 'LM1G', name_pl: 'GRAJEWO - LM1G', },
  { type: 'WA1G', name_pl: 'GRODZISK MAZOWIECKI - WA1G', },
  { type: 'PO1S', name_pl: 'GRODZISK WLKP. - PO1S', },
  { type: 'RA1G', name_pl: 'GRÓJEC - RA1G', },
  { type: 'TO1U', name_pl: 'GRUDZIĄDZ - TO1U', },
  { type: 'SZ1G', name_pl: 'GRYFICE - SZ1G', },
  { type: 'SZ1Y', name_pl: 'GRYFINO - SZ1Y', },
  { type: 'ZG2K', name_pl: 'GUBIN - ZG2K', },
  { type: 'BI2P', name_pl: 'HAJNÓWKA - BI2P', },
  { type: 'ZA1H', name_pl: 'HRUBIESZÓW - ZA1H', },
  { type: 'EL1I', name_pl: 'IŁAWA - EL1I', },
  { type: 'BY1I', name_pl: 'INOWROCŁAW - BY1I', },
  { type: 'ZA1J', name_pl: 'JANÓW LUBELSKI - ZA1J', },
  { type: 'KZ1J', name_pl: 'JAROCIN - KZ1J', },
  { type: 'PR1J', name_pl: 'JAROSŁAW - PR1J', },
  { type: 'KS1J', name_pl: 'JASŁO - KS1J', },
  { type: 'GL1J', name_pl: 'JASTRZĘBIE-ZDRÓJ - GL1J', },
  { type: 'LE1J', name_pl: 'JAWOR - LE1J', },
  { type: 'KA1J', name_pl: 'JAWORZNO - KA1J', },
  { type: 'JG1J', name_pl: 'JELENIA GÓRA - JG1J', },
  { type: 'KI1J', name_pl: 'JĘDRZEJÓW - KI1J', },
  { type: 'KZ1A', name_pl: 'KALISZ - KZ1A', },
  { type: 'JG1K', name_pl: 'KAMIENNA GÓRA - JG1K', },
  { type: 'SZ1K', name_pl: 'KAMIEŃ POMORSKI - SZ1K', },
  { type: 'GD1R', name_pl: 'KARTUZY - GD1R', },
  { type: 'KA1K', name_pl: 'KATOWICE - KA1K', },
  { type: 'KI1I', name_pl: 'KAZIMIERZA WIELKA - KI1I', },
  { type: 'OP1K', name_pl: 'KĘDZIERZYN-KOŹLE - OP1K', },
  { type: 'KZ1E', name_pl: 'KĘPNO - KZ1E', },
  { type: 'OL1K', name_pl: 'KĘTRZYN - OL1K', },
  { type: 'KR2E', name_pl: 'KĘTY - KR2E', },
  { type: 'KI1L', name_pl: 'KIELCE - KI1L', },
  { type: 'OP1U', name_pl: 'KLUCZBORK - OP1U', },
  { type: 'CZ2C', name_pl: 'KŁOBUCK - CZ2C', },
  { type: 'SW1K', name_pl: 'KŁODZKO - SW1K', },
  { type: 'TB1K', name_pl: 'KOLBUSZOWA - TB1K', },
  { type: 'KO1L', name_pl: 'KOŁOBRZEG - KO1L', },
  { type: 'KN1K', name_pl: 'KOŁO - KN1K', },
  { type: 'KN1N', name_pl: 'KONIN - KN1N', },
  { type: 'KI1K', name_pl: 'KOŃSKIE - KI1K', },
  { type: 'KO1K', name_pl: 'KOSZALIN - KO1K', },
  { type: 'PO1K', name_pl: 'KOŚCIAN - PO1K', },
  { type: 'GD1E', name_pl: 'KOŚCIERZYNA - GD1E', },
  { type: 'RA1K', name_pl: 'KOZIENICE - RA1K', },
  { type: 'KR1P', name_pl: 'KRAKÓW - KR1P', },
  { type: 'ZA1K', name_pl: 'KRASNYSTAW - ZA1K', },
  { type: 'LU1K', name_pl: 'KRAŚNIK - LU1K', },
  { type: 'KS1K', name_pl: 'KROSNO - KS1K', },
  { type: 'ZG1K', name_pl: 'KROSNO ODRZAŃSKIE - ZG1K', },
  { type: 'KZ1R', name_pl: 'KROTOSZYN - KZ1R', },
  { type: 'KR2K', name_pl: 'KRZESZOWICE - KR2K', },
  { type: 'LD1K', name_pl: 'KUTNO - LD1K', },
  { type: 'GD1I', name_pl: 'KWIDZYN - GD1I', },
  { type: 'WA1L', name_pl: 'LEGIONOWO - WA1L', },
  { type: 'LE1L', name_pl: 'LEGNICA - LE1L', },
  { type: 'KS1E', name_pl: 'LESKO - KS1E', },
  { type: 'PO1L', name_pl: 'LESZNO - PO1L', },
  { type: 'RZ1E', name_pl: 'LEŻAJSK - RZ1E', },
  { type: 'SL1L', name_pl: 'LĘBORK - SL1L', },
  { type: 'OL1L', name_pl: 'LIDZBARK WARMIŃSKI - OL1L', },
  { type: 'NS1L', name_pl: 'LIMANOWA - NS1L', },
  { type: 'WL1L', name_pl: 'LIPNO - WL1L', },
  { type: 'RA1L', name_pl: 'LIPSKO - RA1L', },
  { type: 'PR1L', name_pl: 'LUBACZÓW - PR1L', },
  { type: 'JG1L', name_pl: 'LUBAŃ - JG1L', },
  { type: 'LU1A', name_pl: 'LUBARTÓW - LU1A', },
  { type: 'LE1U', name_pl: 'LUBIN - LE1U', },
  { type: 'CZ1L', name_pl: 'LUBLINIEC - CZ1L', },
  { type: 'LU1I', name_pl: 'LUBLIN - LU1I', },
  { type: 'JG1S', name_pl: 'LWÓWEK ŚLĄSKI - JG1S', },
  { type: 'RZ1A', name_pl: 'ŁAŃCUT - RZ1A', },
  { type: 'SR1L', name_pl: 'ŁASK - SR1L', },
  { type: 'LD1Y', name_pl: 'ŁĘCZYCA - LD1Y', },
  { type: 'SZ1L', name_pl: 'ŁOBEZ - SZ1L', },
  { type: 'LM1L', name_pl: 'ŁOMŻA - LM1L', },
  { type: 'SI2S', name_pl: 'ŁOSICE - SI2S', },
  { type: 'LD1O', name_pl: 'ŁOWICZ - LD1O', },
  { type: 'LD1M', name_pl: 'ŁÓDŹ - LD1M', },
  { type: 'LU1U', name_pl: 'ŁUKÓW - LU1U', },
  { type: 'GD1M', name_pl: 'MALBORK - GD1M', },
  { type: 'SL1M', name_pl: 'MIASTKO - SL1M', },
  { type: 'KR1M', name_pl: 'MIECHÓW - KR1M', },
  { type: 'TB1M', name_pl: 'MIELEC - TB1M', },
  { type: 'PO2A', name_pl: 'MIĘDZYCHÓD - PO2A', },
  { type: 'GW1M', name_pl: 'MIĘDZYRZECZ - GW1M', },
  { type: 'KA1M', name_pl: 'MIKOŁÓW - KA1M', },
  { type: 'WR1M', name_pl: 'MILICZ - WR1M', },
  { type: 'SI1M', name_pl: 'MIŃSK MAZOWIECKI - SI1M', },
  { type: 'PL1M', name_pl: 'MŁAWA - PL1M', },
  { type: 'BY1M', name_pl: 'MOGILNO - BY1M', },
  { type: 'EL2O', name_pl: 'MORĄG - EL2O', },
  { type: 'OL1M', name_pl: 'MRĄGOWO - OL1M', },
  { type: 'NS2L', name_pl: 'MSZANA DOLNA - NS2L', },
  { type: 'NS1M', name_pl: 'MUSZYNA - NS1M', },
  { type: 'KA1L', name_pl: 'MYSŁOWICE - KA1L', },
  { type: 'CZ1M', name_pl: 'MYSZKÓW - CZ1M', },
  { type: 'KR1Y', name_pl: 'MYŚLENICE - KR1Y', },
  { type: 'SZ1M', name_pl: 'MYŚLIBÓRZ - SZ1M', },
  { type: 'BY1N', name_pl: 'NAKŁO NAD NOTECIĄ - BY1N', },
  { type: 'OL1N', name_pl: 'NIDZICA - OL1N', },
  { type: 'KR2I', name_pl: 'NIEPOŁOMICE - KR2I', },
  { type: 'TB1N', name_pl: 'NISKO - TB1N', },
  { type: 'SW2K', name_pl: 'NOWA RUDA - SW2K', },
  { type: 'ZG1N', name_pl: 'NOWA SÓL - ZG1N', },
  { type: 'EL1N', name_pl: 'NOWE MIASTO LUBAWSKIE - EL1N', },
  { type: 'GD2M', name_pl: 'NOWY DWÓR GDAŃSKI - GD2M', },
  { type: 'WA1N', name_pl: 'NOWY DWÓR MAZOWIECKI - WA1N', },
  { type: 'NS1S', name_pl: 'NOWY SĄCZ - NS1S', },
  { type: 'NS1T', name_pl: 'NOWY TARG - NS1T', },
  { type: 'PO1N', name_pl: 'NOWY TOMYŚL - PO1N', },
  { type: 'OP1N', name_pl: 'NYSA - OP1N', },
  { type: 'PO1O', name_pl: 'OBORNIKI - PO1O', },
  { type: 'OL1C', name_pl: 'OLECKO - OL1C', },
  { type: 'OP1L', name_pl: 'OLESNO - OP1L', },
  { type: 'WR1E', name_pl: 'OLEŚNICA - WR1E', },
  { type: 'KR1O', name_pl: 'OLKUSZ - KR1O', },
  { type: 'OL1O', name_pl: 'OLSZTYN - OL1O', },
  { type: 'WR1O', name_pl: 'OŁAWA - WR1O', },
  { type: 'KI1T', name_pl: 'OPATÓW - KI1T', },
  { type: 'PT1O', name_pl: 'OPOCZNO - PT1O', },
  { type: 'LU1O', name_pl: 'OPOLE LUBELSKIE - LU1O', },
  { type: 'OP1O', name_pl: 'OPOLE - OP1O', },
  { type: 'OS1O', name_pl: 'OSTROŁĘKA - OS1O', },
  { type: 'KI1O', name_pl: 'OSTROWIEC ŚWIĘTOKRZYSKI - KI1O', },
  { type: 'EL1O', name_pl: 'OSTRÓDA - EL1O', },
  { type: 'OS1M', name_pl: 'OSTRÓW MAZOWIECKA - OS1M', },
  { type: 'KZ1W', name_pl: 'OSTRÓW WIELKOPOLSKI - KZ1W', },
  { type: 'KZ1O', name_pl: 'OSTRZESZÓW - KZ1O', },
  { type: 'KR1E', name_pl: 'OŚWIĘCIM - KR1E', },
  { type: 'WA1O', name_pl: 'OTWOCK - WA1O', },
  { type: 'LD1P', name_pl: 'PABIANICE - LD1P', },
  { type: 'SR2W', name_pl: 'PAJĘCZNO - SR2W', },
  { type: 'WA1I', name_pl: 'PIASECZNO - WA1I', },
  { type: 'PO1I', name_pl: 'PIŁA - PO1I', },
  { type: 'KI1P', name_pl: 'PIŃCZÓW - KI1P', },
  { type: 'RA2Z', name_pl: 'PIONKI - RA2Z', },
  { type: 'PT1P', name_pl: 'PIOTRKÓW TRYBUNALSKI - PT1P', },
  { type: 'OL1P', name_pl: 'PISZ - OL1P', },
  { type: 'KZ1P', name_pl: 'PLESZEW - KZ1P', },
  { type: 'PL1P', name_pl: 'PŁOCK - PL1P', },
  { type: 'PL1L', name_pl: 'PŁOŃSK - PL1L', },
  { type: 'SR2L', name_pl: 'PODDĘBICE - SR2L', },
  { type: 'SZ2S', name_pl: 'POLICE - SZ2S', },
  { type: 'PO1P', name_pl: 'POZNAŃ (V) - PO1P', },
  { type: 'PO2P', name_pl: 'POZNAŃ (VI) - PO2P', },
  { type: 'KR1H', name_pl: 'PROSZOWICE - KR1H', },
  { type: 'OP1P', name_pl: 'PRUDNIK - OP1P', },
  { type: 'WA1P', name_pl: 'PRUSZKÓW - WA1P', },
  { type: 'OS1P', name_pl: 'PRZASNYSZ - OS1P', },
  { type: 'PR1P', name_pl: 'PRZEMYŚL - PR1P', },
  { type: 'PR1R', name_pl: 'PRZEWORSK - PR1R', },
  { type: 'RA1P', name_pl: 'PRZYSUCHA - RA1P', },
  { type: 'KA1P', name_pl: 'PSZCZYNA - KA1P', },
  { type: 'GD2W', name_pl: 'PUCK - GD2W', },
  { type: 'LU1P', name_pl: 'PUŁAWY - LU1P', },
  { type: 'OS1U', name_pl: 'PUŁTUSK - OS1U', },
  { type: 'SZ2T', name_pl: 'PYRZYCE - SZ2T', },
  { type: 'GL1R', name_pl: 'RACIBÓRZ - GL1R', },
  { type: 'RA1R', name_pl: 'RADOM - RA1R', },
  { type: 'PT1R', name_pl: 'RADOMSKO - PT1R', },
  { type: 'WL1R', name_pl: 'RADZIEJÓW - WL1R', },
  { type: 'LU1R', name_pl: 'RADZYŃ PODLASKI - LU1R', },
  { type: 'LD1R', name_pl: 'RAWA MAZOWIECKA - LD1R', },
  { type: 'PO1R', name_pl: 'RAWICZ - PO1R', },
  { type: 'RZ1R', name_pl: 'ROPCZYCE - RZ1R', },
  { type: 'GL1S', name_pl: 'RUDA ŚLĄSKA - GL1S', },
  { type: 'GL1Y', name_pl: 'RYBNIK - GL1Y', },
  { type: 'LU1Y', name_pl: 'RYKI - LU1Y', },
  { type: 'WL1Y', name_pl: 'RYPIN - WL1Y', },
  { type: 'RZ1Z', name_pl: 'RZESZÓW - RZ1Z', },
  { type: 'KI1S', name_pl: 'SANDOMIERZ - KI1S', },
  { type: 'KS1S', name_pl: 'SANOK - KS1S', },
  { type: 'SU1N', name_pl: 'SEJNY - SU1N', },
  { type: 'BY2T', name_pl: 'SĘPÓLNO KRAJEŃSKIE - BY2T', },
  { type: 'SI1S', name_pl: 'SIEDLCE - SI1S', },
  { type: 'KA1I', name_pl: 'SIEMIANOWICE ŚLĄSKIE - KA1I', },
  { type: 'BI3P', name_pl: 'SIEMIATYCZE - BI3P', },
  { type: 'PR2R', name_pl: 'SIENIAWA - PR2R', },
  { type: 'SR1S', name_pl: 'SIERADZ - SR1S', },
  { type: 'PL1E', name_pl: 'SIERPC - PL1E', },
  { type: 'KR2P', name_pl: 'SKAŁA - KR2P', },
  { type: 'KI1R', name_pl: 'SKARŻYSKO-KAMIENNA - KI1R', },
  { type: 'KR3I', name_pl: 'SKAWINA - KR3I', },
  { type: 'LD1H', name_pl: 'SKIERNIEWICE - LD1H', },
  { type: 'KO1E', name_pl: 'SŁAWNO - KO1E', },
  { type: 'KR1S', name_pl: 'SŁOMNIKI - KR1S', },
  { type: 'GW1S', name_pl: 'SŁUBICE - GW1S', },
  { type: 'KN1S', name_pl: 'SŁUPCA - KN1S', },
  { type: 'SL1S', name_pl: 'SŁUPSK - SL1S', },
  { type: 'PL1O', name_pl: 'SOCHACZEW - PL1O', },
  { type: 'SI1P', name_pl: 'SOKOŁÓW PODLASKI - SI1P', },
  { type: 'BI1S', name_pl: 'SOKÓŁKA - BI1S', },
  { type: 'GD1S', name_pl: 'SOPOT - GD1S', },
  { type: 'KA1S', name_pl: 'SOSNOWIEC - KA1S', },
  { type: 'TB1S', name_pl: 'STALOWA WOLA - TB1S', },
  { type: 'KI1H', name_pl: 'STARACHOWICE - KI1H', },
  { type: 'SZ1T', name_pl: 'STARGARD - SZ1T', },
  { type: 'GD1A', name_pl: 'STAROGARD GDAŃSKI - GD1A', },
  { type: 'KI1A', name_pl: 'STASZÓW - KI1A', },
  { type: 'GW1K', name_pl: 'STRZELCE KRAJEŃSKIE - GW1K', },
  { type: 'OP1S', name_pl: 'STRZELCE OPOLSKIE - OP1S', },
  { type: 'WR1T', name_pl: 'STRZELIN - WR1T', },
  { type: 'RZ1S', name_pl: 'STRZYŻÓW - RZ1S', },
  { type: 'KR1B', name_pl: 'SUCHA BESKIDZKA - KR1B', },
  { type: 'ZG2S', name_pl: 'SULECHÓW - ZG2S', },
  { type: 'GW1U', name_pl: 'SULĘCIN - GW1U', },
  { type: 'SU1S', name_pl: 'SUWAŁKI - SU1S', },
  { type: 'PO1A', name_pl: 'SZAMOTUŁY - PO1A', },
  { type: 'KO1I', name_pl: 'SZCZECINEK - KO1I', },
  { type: 'SZ1S', name_pl: 'SZCZECIN - SZ1S', },
  { type: 'OL1S', name_pl: 'SZCZYTNO - OL1S', },
  { type: 'GD2I', name_pl: 'SZTUM - GD2I', },
  { type: 'BY1U', name_pl: 'SZUBIN - BY1U', },
  { type: 'RA1S', name_pl: 'SZYDŁOWIEC - RA1S', },
  { type: 'PO1M', name_pl: 'ŚREM - PO1M', },
  { type: 'WR1S', name_pl: 'ŚRODA ŚLĄSKA - WR1S', },
  { type: 'PO1D', name_pl: 'ŚRODA WLKP. - PO1D', },
  { type: 'SW1S', name_pl: 'ŚWIDNICA - SW1S', },
  { type: 'LU1S', name_pl: 'ŚWIDNIK - LU1S', },
  { type: 'KO2B', name_pl: 'ŚWIDWIN - KO2B', },
  { type: 'ZG1S', name_pl: 'ŚWIEBODZIN - ZG1S', },
  { type: 'BY1S', name_pl: 'ŚWIECIE - BY1S', },
  { type: 'SZ1W', name_pl: 'ŚWINOUJŚCIE - SZ1W', },
  { type: 'TB1T', name_pl: 'TARNOBRZEG - TB1T', },
  { type: 'GL1T', name_pl: 'TARNOWSKIE GÓRY - GL1T', },
  { type: 'TR1T', name_pl: 'TARNÓW - TR1T', },
  { type: 'GD1T', name_pl: 'TCZEW - GD1T', },
  { type: 'ZA1T', name_pl: 'TOMASZÓW LUBELSKI - ZA1T', },
  { type: 'PT1T', name_pl: 'TOMASZÓW MAZOWIECKI - PT1T', },
  { type: 'TO1T', name_pl: 'TORUŃ - TO1T', },
  { type: 'PO1T', name_pl: 'TRZCIANKA - PO1T', },
  { type: 'WR1W', name_pl: 'TRZEBNICA - WR1W', },
  { type: 'BY1T', name_pl: 'TUCHOLA - BY1T', },
  { type: 'TR2T', name_pl: 'TUCHÓW - TR2T', },
  { type: 'KN1T', name_pl: 'TUREK - KN1T', },
  { type: 'KA1T', name_pl: 'TYCHY - KA1T', },
  { type: 'RZ2Z', name_pl: 'TYCZYN - RZ2Z', },
  { type: 'KS2E', name_pl: 'USTRZYKI DOLNE - KS2E', },
  { type: 'KR1W', name_pl: 'WADOWICE - KR1W', },
  { type: 'SW1W', name_pl: 'WAŁBRZYCH - SW1W', },
  { type: 'KO1W', name_pl: 'WAŁCZ - KO1W', },
  { type: 'WA3M', name_pl: 'WARSZAWA (IX) - WA3M', },
  { type: 'WA1M', name_pl: 'WARSZAWA (VI) - WA1M', },
  { type: 'WA2M', name_pl: 'WARSZAWA (VII) - WA2M', },
  { type: 'WA4M', name_pl: 'WARSZAWA (X) - WA4M', },
  { type: 'WA5M', name_pl: 'WARSZAWA (XIII) - WA5M', },
  { type: 'WA6M', name_pl: 'WARSZAWA (XV) - WA6M', },
  { type: 'CIKW', name_pl: 'WARSZAWA - CIKW', },
  { type: 'TO1W', name_pl: 'WĄBRZEŹNO - TO1W', },
  { type: 'PO1B', name_pl: 'WĄGROWIEC - PO1B', },
  { type: 'GD1W', name_pl: 'WEJHEROWO - GD1W', },
  { type: 'OL2G', name_pl: 'WĘGORZEWO - OL2G', },
  { type: 'SI1W', name_pl: 'WĘGRÓW - SI1W', },
  { type: 'KR1I', name_pl: 'WIELICZKA - KR1I', },
  { type: 'SR1W', name_pl: 'WIELUŃ - SR1W', },
  { type: 'WL1W', name_pl: 'WŁOCŁAWEK - WL1W', },
  { type: 'LU1W', name_pl: 'WŁODAWA - LU1W', },
  { type: 'KI1W', name_pl: 'WŁOSZCZOWA - KI1W', },
  { type: 'GL1W', name_pl: 'WODZISŁAW ŚLĄSKI - GL1W', },
  { type: 'PO1E', name_pl: 'WOLSZTYN - PO1E', },
  { type: 'WA1W', name_pl: 'WOŁOMIN - WA1W', },
  { type: 'WR1L', name_pl: 'WOŁÓW - WR1L', },
  { type: 'WR1K', name_pl: 'WROCŁAW - WR1K', },
  { type: 'PO1F', name_pl: 'WRZEŚNIA - PO1F', },
  { type: 'ZG1W', name_pl: 'WSCHOWA - ZG1W', },
  { type: 'PO2H', name_pl: 'WYRZYSK - PO2H', },
  { type: 'LM1W', name_pl: 'WYSOKIE MAZOWIECKIE - LM1W', },
  { type: 'OS1W', name_pl: 'WYSZKÓW - OS1W', },
  { type: 'GL1Z', name_pl: 'ZABRZE - GL1Z', },
  { type: 'NS1Z', name_pl: 'ZAKOPANE - NS1Z', },
  { type: 'LM1Z', name_pl: 'ZAMBRÓW - LM1Z', },
  { type: 'ZA1Z', name_pl: 'ZAMOŚĆ - ZA1Z', },
  { type: 'CZ1Z', name_pl: 'ZAWIERCIE - CZ1Z', },
  { type: 'SW1Z', name_pl: 'ZĄBKOWICE ŚLĄSKIE - SW1Z', },
  { type: 'SR1Z', name_pl: 'ZDUŃSKA WOLA - SR1Z', },
  { type: 'LD1G', name_pl: 'ZGIERZ - LD1G', },
  { type: 'JG1Z', name_pl: 'ZGORZELEC - JG1Z', },
  { type: 'ZG1E', name_pl: 'ZIELONA GÓRA - ZG1E', },
  { type: 'LE1Z', name_pl: 'ZŁOTORYJA - LE1Z', },
  { type: 'PO1Z', name_pl: 'ZŁOTÓW - PO1Z', },
  { type: 'RA1Z', name_pl: 'ZWOLEŃ - RA1Z', },
  { type: 'ZG1G', name_pl: 'ŻAGAŃ - ZG1G', },
  { type: 'ZG1R', name_pl: 'ŻARY - ZG1R', },
  { type: 'BY1Z', name_pl: 'ŻNIN - BY1Z', },
  { type: 'GL1X', name_pl: 'ŻORY - GL1X', },
  { type: 'PL2M', name_pl: 'ŻUROMIN - PL2M', },
  { type: 'PL1Z', name_pl: 'ŻYRARDÓW - PL1Z', },
  { type: 'BB1Z', name_pl: 'ŻYWIEC - BB1Z', },
  { type: 'DIRS', name_pl: 'ŻŻ DIRS - DIRS', },
];
export type Currency = 'PLN' | 'EUR' | 'CHF' | 'GBP' | 'NOK' | 'SEK' | 'USD' | 'RON'

export const currencyDictionary: IMultiformDictionary<Currency> = [
  {type: 'PLN' as const, name_pl: I18NGetter().useCurrencyDictionary.PLN, },
  {type: 'EUR' as const, name_pl: I18NGetter().useCurrencyDictionary.EUR, },
  {type: 'CHF' as const, name_pl: I18NGetter().useCurrencyDictionary.CHF, },
  {type: 'GBP' as const, name_pl: I18NGetter().useCurrencyDictionary.GBP, },
  {type: 'NOK' as const, name_pl: I18NGetter().useCurrencyDictionary.NOK, },
  {type: 'SEK' as const, name_pl: I18NGetter().useCurrencyDictionary.SEK, },
  {type: 'USD' as const, name_pl: I18NGetter().useCurrencyDictionary.USD, },
  {type: 'RON' as const, name_pl: I18NGetter().useCurrencyDictionary.RON, },
].filter((item) =>
  appDomainConfig.supportedCurrencies.includes(item.type)
);

export const landDictionary: IMultiformDictionary<number> = [
  {type: 2, name_pl: 'dolnośląskie', },
  {type: 4, name_pl: 'kujawsko-pomorskie', },
  {type: 6, name_pl: 'lubelskie', },
  {type: 8, name_pl: 'lubuskie', },
  {type: 10, name_pl: 'łódzkie', },
  {type: 12, name_pl: 'małopolskie', },
  {type: 14, name_pl: 'mazowieckie', },
  {type: 16, name_pl: 'opolskie', },
  {type: 18, name_pl: 'podkarpackie', },
  {type: 20, name_pl: 'podlaskie', },
  {type: 22, name_pl: 'pomorskie', },
  {type: 24, name_pl: 'śląskie', },
  {type: 26, name_pl: 'świętokrzyskie', },
  {type: 28, name_pl: 'warmińsko-mazurskie', },
  {type: 30, name_pl: 'wielkopolskie', },
  {type: 32, name_pl: 'zachodniopomorskie', },
];

export const districtDictionary: IMultiformDistrictDictionary<number> = [
  { type: 1, name_pl: 'bolesławiecki', landId: 2, population: 89051, },
  { type: 2, name_pl: 'dzierżoniowski', landId: 2, population: 103636, },
  { type: 3, name_pl: 'głogowski', landId: 2, population: 87712, },
  { type: 4, name_pl: 'górowski', landId: 2, population: 36317, },
  { type: 5, name_pl: 'jaworski', landId: 2, population: 51581, },
  { type: 6, name_pl: 'karkonoski', landId: 2, population: 63865, },
  { type: 7, name_pl: 'kamiennogórski', landId: 2, population: 45562, },
  { type: 8, name_pl: 'kłodzki', landId: 2, population: 163648, },
  { type: 9, name_pl: 'legnicki', landId: 2, population: 53618, },
  { type: 10, name_pl: 'lubański', landId: 2, population: 56085, },
  { type: 11, name_pl: 'lubiński', landId: 2, population: 105170, },
  { type: 12, name_pl: 'lwówecki', landId: 2, population: 47194, },
  { type: 13, name_pl: 'milicki', landId: 2, population: 37036, },
  { type: 14, name_pl: 'oleśnicki', landId: 2, population: 104047, },
  { type: 15, name_pl: 'oławski', landId: 2, population: 72357, },
  { type: 16, name_pl: 'polkowicki', landId: 2, population: 61622, },
  { type: 17, name_pl: 'strzeliński', landId: 2, population: 43873, },
  { type: 18, name_pl: 'średzki', landId: 2, population: 50119, },
  { type: 19, name_pl: 'świdnicki', landId: 2, population: 159323, },
  { type: 20, name_pl: 'trzebnicki', landId: 2, population: 79166, },
  { type: 21, name_pl: 'wałbrzyski', landId: 2, population: 179526, },
  { type: 22, name_pl: 'wołowski', landId: 2, population: 47344, },
  { type: 23, name_pl: 'wrocławski', landId: 2, population: 111069, },
  { type: 24, name_pl: 'ząbkowicki', landId: 2, population: 68575, },
  { type: 25, name_pl: 'zgorzelecki', landId: 2, population: 92867, },
  { type: 26, name_pl: 'złotoryjski', landId: 2, population: 45376, },
  { type: 27, name_pl: 'm. Jelenia Góra', landId: 2, population: 84564, },
  { type: 28, name_pl: 'm. Legnica', landId: 2, population: 104178, },
  { type: 29, name_pl: 'm. Wrocław', landId: 2, population: 632146, },
  { type: 30, name_pl: 'aleksandrowski', landId: 4, population: 55336, },
  { type: 31, name_pl: 'brodnicki', landId: 4, population: 75579, },
  { type: 32, name_pl: 'bydgoski', landId: 4, population: 103010, },
  { type: 33, name_pl: 'chełmiński', landId: 4, population: 51456, },
  { type: 34, name_pl: 'golubsko-dobrzyński', landId: 4, population: 45281, },
  { type: 35, name_pl: 'grudziądzki', landId: 4, population: 38708, },
  { type: 36, name_pl: 'inowrocławski', landId: 4, population: 164112, },
  { type: 37, name_pl: 'lipnowski', landId: 4, population: 66162, },
  { type: 38, name_pl: 'mogileński', landId: 4, population: 46877, },
  { type: 39, name_pl: 'nakielski', landId: 4, population: 85397, },
  { type: 40, name_pl: 'radziejowski', landId: 4, population: 41793, },
  { type: 41, name_pl: 'rypiński', landId: 4, population: 43902, },
  { type: 42, name_pl: 'sępoleński', landId: 4, population: 41045, },
  { type: 43, name_pl: 'świecki', landId: 4, population: 97642, },
  { type: 44, name_pl: 'toruński', landId: 4, population: 95187, },
  { type: 45, name_pl: 'tucholski', landId: 4, population: 47622, },
  { type: 46, name_pl: 'wąbrzeski', landId: 4, population: 34777, },
  { type: 47, name_pl: 'włocławski', landId: 4, population: 85368, },
  { type: 48, name_pl: 'żniński', landId: 4, population: 69985, },
  { type: 49, name_pl: 'm. Bydgoszcz', landId: 4, population: 357650, },
  { type: 50, name_pl: 'm. Grudziądz', landId: 4, population: 99074, },
  { type: 51, name_pl: 'm. Toruń', landId: 4, population: 205718, },
  { type: 52, name_pl: 'Włocławek', landId: 4, population: 117402, },
  { type: 53, name_pl: 'bialski', landId: 6, population: 112846, },
  { type: 54, name_pl: 'biłgorajski', landId: 6, population: 103226, },
  { type: 55, name_pl: 'chełmski', landId: 6, population: 78765, },
  { type: 56, name_pl: 'hrubieszowski', landId: 6, population: 67059, },
  { type: 57, name_pl: 'janowski', landId: 6, population: 47242, },
  { type: 58, name_pl: 'krasnostawski', landId: 6, population: 67824, },
  { type: 59, name_pl: 'kraśnicki', landId: 6, population: 98574, },
  { type: 60, name_pl: 'lubartowski', landId: 6, population: 89876, },
  { type: 61, name_pl: 'lubelski', landId: 6, population: 144383, },
  { type: 62, name_pl: 'łęczyński', landId: 6, population: 57164, },
  { type: 63, name_pl: 'łukowski', landId: 6, population: 107953, },
  { type: 64, name_pl: 'opolski', landId: 6, population: 62048, },
  { type: 65, name_pl: 'parczewski', landId: 6, population: 35921, },
  { type: 66, name_pl: 'puławski', landId: 6, population: 115860, },
  { type: 67, name_pl: 'radzyński', landId: 6, population: 60866, },
  { type: 68, name_pl: 'rycki', landId: 6, population: 58342, },
  { type: 69, name_pl: 'świdnicki', landId: 6, population: 72366, },
  { type: 70, name_pl: 'tomaszowski', landId: 6, population: 86657, },
  { type: 71, name_pl: 'włodawski', landId: 6, population: 39526, },
  { type: 72, name_pl: 'zamojski', landId: 6, population: 109181, },
  { type: 73, name_pl: 'm. Biała Podlaska', landId: 6, population: 57876, },
  { type: 74, name_pl: 'm. Chełm', landId: 6, population: 67650, },
  { type: 75, name_pl: 'm. Lublin', landId: 6, population: 349440, },
  { type: 76, name_pl: 'm. Zamość', landId: 6, population: 66557, },
  { type: 77, name_pl: 'gorzowski', landId: 8, population: 67443, },
  { type: 78, name_pl: 'krośnieński', landId: 8, population: 56131, },
  { type: 79, name_pl: 'międzyrzecki', landId: 8, population: 58250, },
  { type: 80, name_pl: 'nowosolski', landId: 8, population: 86890, },
  { type: 81, name_pl: 'słubicki', landId: 8, population: 46413, },
  { type: 82, name_pl: 'strzelecko-drezdenecki', landId: 8, population: 49789, },
  { type: 83, name_pl: 'sulęciński', landId: 8, population: 35492, },
  { type: 84, name_pl: 'świebodziński', landId: 8, population: 56038, },
  { type: 85, name_pl: 'zielonogórski', landId: 8, population: 91638, },
  { type: 86, name_pl: 'żagański', landId: 8, population: 81658, },
  { type: 87, name_pl: 'żarski', landId: 8, population: 98364, },
  { type: 88, name_pl: 'wschowski', landId: 8, population: 39055, },
  { type: 89, name_pl: 'm. Gorzów Wielkopolski', landId: 8, population: 125383, },
  { type: 90, name_pl: 'm. Zielona Góra', landId: 8, population: 117503, },
  { type: 91, name_pl: 'bełchatowski', landId: 10, population: 112993, },
  { type: 92, name_pl: 'kutnowski', landId: 10, population: 102015, },
  { type: 93, name_pl: 'łaski', landId: 10, population: 50808, },
  { type: 94, name_pl: 'łęczycki', landId: 10, population: 52420, },
  { type: 95, name_pl: 'łowicki', landId: 10, population: 81151, },
  { type: 96, name_pl: 'łódzki wschodni', landId: 10, population: 66807, },
  { type: 97, name_pl: 'opoczyński', landId: 10, population: 78362, },
  { type: 98, name_pl: 'pabianicki', landId: 10, population: 119060, },
  { type: 99, name_pl: 'pajęczański', landId: 10, population: 52750, },
  { type: 100, name_pl: 'piotrkowski', landId: 10, population: 90462, },
  { type: 101, name_pl: 'poddębicki', landId: 10, population: 41618, },
  { type: 102, name_pl: 'radomszczański', landId: 10, population: 117431, },
  { type: 103, name_pl: 'rawski', landId: 10, population: 49053, },
  { type: 104, name_pl: 'sieradzki', landId: 10, population: 119916, },
  { type: 105, name_pl: 'skierniewicki', landId: 10, population: 37604, },
  { type: 106, name_pl: 'tomaszowski', landId: 10, population: 120132, },
  { type: 107, name_pl: 'wieluński', landId: 10, population: 77843, },
  { type: 108, name_pl: 'wieruszowski', landId: 10, population: 42168, },
  { type: 109, name_pl: 'zduńskowolski', landId: 10, population: 67588, },
  { type: 110, name_pl: 'zgierski', landId: 10, population: 161959, },
  { type: 111, name_pl: 'brzeziński', landId: 10, population: 30537, },
  { type: 112, name_pl: 'm. Łódź', landId: 10, population: 742387, },
  { type: 113, name_pl: 'Piotrków Trybunalski', landId: 10, population: 77810, },
  { type: 114, name_pl: 'Skierniewice', landId: 10, population: 48958, },
  { type: 115, name_pl: 'bocheński', landId: 12, population: 102181, },
  { type: 116, name_pl: 'brzeski', landId: 12, population: 91297, },
  { type: 117, name_pl: 'chrzanowski', landId: 12, population: 127645, },
  { type: 118, name_pl: 'dąbrowski', landId: 12, population: 58664, },
  { type: 119, name_pl: 'gorlicki', landId: 12, population: 107017, },
  { type: 120, name_pl: 'krakowski', landId: 12, population: 253344, },
  { type: 121, name_pl: 'limanowski', landId: 12, population: 124278, },
  { type: 122, name_pl: 'miechowski', landId: 12, population: 50114, },
  { type: 123, name_pl: 'myślenicki', landId: 12, population: 119975, },
  { type: 124, name_pl: 'nowosądecki', landId: 12, population: 202701, },
  { type: 125, name_pl: 'nowotarski', landId: 12, population: 185161, },
  { type: 126, name_pl: 'olkuski', landId: 12, population: 113893, },
  { type: 127, name_pl: 'oświęcimski', landId: 12, population: 153602, },
  { type: 128, name_pl: 'proszowicki', landId: 12, population: 43419, },
  { type: 129, name_pl: 'suski', landId: 12, population: 82736, },
  { type: 130, name_pl: 'tarnowski', landId: 12, population: 195908, },
  { type: 131, name_pl: 'tatrzański', landId: 12, population: 65298, },
  { type: 132, name_pl: 'wadowicki', landId: 12, population: 155923, },
  { type: 133, name_pl: 'wielicki', landId: 12, population: 110400, },
  { type: 134, name_pl: 'm. Kraków', landId: 12, population: 755000, },
  { type: 135, name_pl: 'm. Nowy Sącz', landId: 12, population: 84556, },
  { type: 136, name_pl: 'm. Tarnów', landId: 12, population: 115158, },
  { type: 137, name_pl: 'białobrzeski', landId: 14, population: 33701, },
  { type: 138, name_pl: 'ciechanowski', landId: 14, population: 90249, },
  { type: 139, name_pl: 'garwoliński', landId: 14, population: 106927, },
  { type: 140, name_pl: 'gostyniński', landId: 14, population: 46766, },
  { type: 141, name_pl: 'grodziski', landId: 14, population: 81923, },
  { type: 142, name_pl: 'grójecki', landId: 14, population: 96957, },
  { type: 143, name_pl: 'kozienicki', landId: 14, population: 61199, },
  { type: 144, name_pl: 'legionowski', landId: 14, population: 103039, },
  { type: 145, name_pl: 'lipski', landId: 14, population: 36033, },
  { type: 146, name_pl: 'łosicki', landId: 14, population: 32072, },
  { type: 147, name_pl: 'makowski', landId: 14, population: 46068, },
  { type: 148, name_pl: 'miński', landId: 14, population: 144294, },
  { type: 149, name_pl: 'mławski', landId: 14, population: 72713, },
  { type: 150, name_pl: 'nowodworski', landId: 14, population: 76583, },
  { type: 151, name_pl: 'ostrołęcki', landId: 14, population: 84578, },
  { type: 152, name_pl: 'ostrowski', landId: 14, population: 74511, },
  { type: 153, name_pl: 'otwocki', landId: 14, population: 119607, },
  { type: 154, name_pl: 'piaseczyński', landId: 14, population: 157392, },
  { type: 155, name_pl: 'płocki', landId: 14, population: 107471, },
  { type: 156, name_pl: 'płoński', landId: 14, population: 87244, },
  { type: 157, name_pl: 'pruszkowski', landId: 14, population: 150270, },
  { type: 158, name_pl: 'przasnyski', landId: 14, population: 52389, },
  { type: 159, name_pl: 'przysuski', landId: 14, population: 43064, },
  { type: 160, name_pl: 'pułtuski', landId: 14, population: 50994, },
  { type: 161, name_pl: 'radomski', landId: 14, population: 147212, },
  { type: 162, name_pl: 'siedlecki', landId: 14, population: 80509, },
  { type: 163, name_pl: 'sierpecki', landId: 14, population: 53028, },
  { type: 164, name_pl: 'sochaczewski', landId: 14, population: 83928, },
  { type: 165, name_pl: 'sokołowski', landId: 14, population: 55832, },
  { type: 166, name_pl: 'szydłowiecki', landId: 14, population: 39912, },
  { type: 167, name_pl: 'warszawski zachodni', landId: 14, population: 105185, },
  { type: 168, name_pl: 'węgrowski', landId: 14, population: 67080, },
  { type: 169, name_pl: 'wołomiński', landId: 14, population: 213714, },
  { type: 170, name_pl: 'wyszkowski', landId: 14, population: 72307, },
  { type: 171, name_pl: 'zwoleński', landId: 14, population: 36796, },
  { type: 172, name_pl: 'żuromiński', landId: 14, population: 39671, },
  { type: 173, name_pl: 'żyrardowski', landId: 14, population: 75408, },
  { type: 174, name_pl: 'Ostrołęka', landId: 14, population: 53837, },
  { type: 175, name_pl: 'm. Płock', landId: 14, population: 126542, },
  { type: 176, name_pl: 'm. Radom', landId: 14, population: 223397, },
  { type: 177, name_pl: 'm. Siedlce', landId: 14, population: 77319, },
  { type: 178, name_pl: 'm. Warszawa', landId: 14, population: 1714446, },
  { type: 179, name_pl: 'brzeski', landId: 16, population: 92188, },
  { type: 180, name_pl: 'głubczycki', landId: 16, population: 49422, },
  { type: 181, name_pl: 'kędzierzyńsko-kozielski', landId: 16, population: 100320, },
  { type: 182, name_pl: 'kluczborski', landId: 16, population: 68801, },
  { type: 183, name_pl: 'krapkowicki', landId: 16, population: 66795, },
  { type: 184, name_pl: 'namysłowski', landId: 16, population: 43814, },
  { type: 185, name_pl: 'nyski', landId: 16, population: 143852, },
  { type: 186, name_pl: 'oleski', landId: 16, population: 67194, },
  { type: 187, name_pl: 'opolski', landId: 16, population: 135010, },
  { type: 188, name_pl: 'prudnicki', landId: 16, population: 58732, },
  { type: 189, name_pl: 'strzelecki', landId: 16, population: 79177, },
  { type: 190, name_pl: 'm. Opole', landId: 16, population: 125792, },
  { type: 191, name_pl: 'bieszczadzki', landId: 18, population: 22001, },
  { type: 192, name_pl: 'brzozowski', landId: 18, population: 65253, },
  { type: 193, name_pl: 'dębicki', landId: 18, population: 133244, },
  { type: 194, name_pl: 'jarosławski', landId: 18, population: 121654, },
  { type: 195, name_pl: 'jasielski', landId: 18, population: 114689, },
  { type: 196, name_pl: 'kolbuszowski', landId: 18, population: 61546, },
  { type: 197, name_pl: 'krośnieński', landId: 18, population: 110849, },
  { type: 198, name_pl: 'leżajski', landId: 18, population: 69105, },
  { type: 199, name_pl: 'lubaczowski', landId: 18, population: 56811, },
  { type: 200, name_pl: 'łańcucki', landId: 18, population: 78359, },
  { type: 201, name_pl: 'mielecki', landId: 18, population: 133986, },
  { type: 202, name_pl: 'niżański', landId: 18, population: 66947, },
  { type: 203, name_pl: 'przemyski', landId: 18, population: 71231, },
  { type: 204, name_pl: 'przeworski', landId: 18, population: 78630, },
  { type: 205, name_pl: 'ropczycko-sędziszowski', landId: 18, population: 71751, },
  { type: 206, name_pl: 'rzeszowski', landId: 18, population: 164900, },
  { type: 207, name_pl: 'sanocki', landId: 18, population: 94857, },
  { type: 208, name_pl: 'stalowowolski', landId: 18, population: 107815, },
  { type: 209, name_pl: 'strzyżowski', landId: 18, population: 61897, },
  { type: 210, name_pl: 'tarnobrzeski', landId: 18, population: 53487, },
  { type: 211, name_pl: 'leski', landId: 18, population: 26608, },
  { type: 212, name_pl: 'm. Krosno', landId: 18, population: 47534, },
  { type: 213, name_pl: 'm. Przemyśl', landId: 18, population: 66389, },
  { type: 214, name_pl: 'm. Rzeszów', landId: 18, population: 172770, },
  { type: 215, name_pl: 'Tarnobrzeg', landId: 18, population: 49419, },
  { type: 216, name_pl: 'augustowski', landId: 20, population: 58763, },
  { type: 217, name_pl: 'białostocki', landId: 20, population: 139643, },
  { type: 218, name_pl: 'bielski', landId: 20, population: 58463, },
  { type: 219, name_pl: 'grajewski', landId: 20, population: 49393, },
  { type: 220, name_pl: 'hajnowski', landId: 20, population: 46385, },
  { type: 221, name_pl: 'kolneński', landId: 20, population: 39053, },
  { type: 222, name_pl: 'łomżyński', landId: 20, population: 50919, },
  { type: 223, name_pl: 'moniecki', landId: 20, population: 42212, },
  { type: 224, name_pl: 'sejneński', landId: 20, population: 21013, },
  { type: 225, name_pl: 'siemiatycki', landId: 20, population: 47286, },
  { type: 226, name_pl: 'sokólski', landId: 20, population: 70517, },
  { type: 227, name_pl: 'suwalski', landId: 20, population: 35148, },
  { type: 228, name_pl: 'wysokomazowiecki', landId: 20, population: 59010, },
  { type: 229, name_pl: 'zambrowski', landId: 20, population: 44385, },
  { type: 230, name_pl: 'm. Białystok', landId: 20, population: 294685, },
  { type: 231, name_pl: 'm. Łomża', landId: 20, population: 63357, },
  { type: 232, name_pl: 'm. Suwałki', landId: 20, population: 69499, },
  { type: 233, name_pl: 'bytowski', landId: 22, population: 76043, },
  { type: 234, name_pl: 'chojnicki', landId: 22, population: 93411, },
  { type: 235, name_pl: 'człuchowski', landId: 22, population: 56762, },
  { type: 236, name_pl: 'gdański', landId: 22, population: 93191, },
  { type: 237, name_pl: 'kartuski', landId: 22, population: 116000, },
  { type: 238, name_pl: 'kościerski', landId: 22, population: 68311, },
  { type: 239, name_pl: 'kwidzyński', landId: 22, population: 81848, },
  { type: 240, name_pl: 'lęborski', landId: 22, population: 63915, },
  { type: 241, name_pl: 'malborski', landId: 22, population: 62842, },
  { type: 242, name_pl: 'nowodworski', landId: 22, population: 35642, },
  { type: 243, name_pl: 'pucki', landId: 22, population: 77238, },
  { type: 244, name_pl: 'słupski', landId: 22, population: 93230, },
  { type: 245, name_pl: 'starogardzki', landId: 22, population: 124056, },
  { type: 246, name_pl: 'tczewski', landId: 22, population: 113570, },
  { type: 247, name_pl: 'wejherowski', landId: 22, population: 192349, },
  { type: 248, name_pl: 'sztumski', landId: 22, population: 41694, },
  { type: 249, name_pl: 'm. Gdańsk', landId: 22, population: 456591, },
  { type: 250, name_pl: 'm. Gdynia', landId: 22, population: 247859, },
  { type: 251, name_pl: 'm. Słupsk', landId: 22, population: 97087, },
  { type: 252, name_pl: 'm. Sopot', landId: 22, population: 38460, },
  { type: 253, name_pl: 'będziński', landId: 24, population: 150950, },
  { type: 254, name_pl: 'bielski', landId: 24, population: 155571, },
  { type: 255, name_pl: 'cieszyński', landId: 24, population: 172809, },
  { type: 256, name_pl: 'częstochowski', landId: 24, population: 134103, },
  { type: 257, name_pl: 'gliwicki', landId: 24, population: 114093, },
  { type: 258, name_pl: 'kłobucki', landId: 24, population: 85001, },
  { type: 259, name_pl: 'lubliniecki', landId: 24, population: 76618, },
  { type: 260, name_pl: 'mikołowski', landId: 24, population: 92655, },
  { type: 261, name_pl: 'myszkowski', landId: 24, population: 71517, },
  { type: 262, name_pl: 'pszczyński', landId: 24, population: 106361, },
  { type: 263, name_pl: 'raciborski', landId: 24, population: 110448, },
  { type: 264, name_pl: 'rybnicki', landId: 24, population: 74509, },
  { type: 265, name_pl: 'tarnogórski', landId: 24, population: 137496, },
  { type: 266, name_pl: 'bieruńsko-lędziński', landId: 24, population: 56806, },
  { type: 267, name_pl: 'wodzisławski', landId: 24, population: 155982, },
  { type: 268, name_pl: 'zawierciański', landId: 24, population: 122628, },
  { type: 269, name_pl: 'żywiecki', landId: 24, population: 150850, },
  { type: 270, name_pl: 'm. Bielsko-Biała', landId: 24, population: 175402, },
  { type: 271, name_pl: 'm. Bytom', landId: 24, population: 182749, },
  { type: 272, name_pl: 'm. Chorzów', landId: 24, population: 113007, },
  { type: 273, name_pl: 'm. Częstochowa', landId: 24, population: 239319, },
  { type: 274, name_pl: 'm. Dąbrowa Górnicza', landId: 24, population: 127686, },
  { type: 275, name_pl: 'm. Gliwice', landId: 24, population: 196167, },
  { type: 276, name_pl: 'm. Jastrzębie-Zdrój', landId: 24, population: 92988, },
  { type: 277, name_pl: 'm. Jaworzno', landId: 24, population: 95036, },
  { type: 278, name_pl: 'm. Katowice', landId: 24, population: 308548, },
  { type: 279, name_pl: 'm. Mysłowice', landId: 24, population: 74893, },
  { type: 280, name_pl: 'm. Piekary Śląskie', landId: 24, population: 58519, },
  { type: 281, name_pl: 'm. Ruda Śląska', landId: 24, population: 143394, },
  { type: 282, name_pl: 'm. Rybnik', landId: 24, population: 141372, },
  { type: 283, name_pl: 'm. Siemianowice Śląskie', landId: 24, population: 70712, },
  { type: 284, name_pl: 'm. Sosnowiec', landId: 24, population: 219300, },
  { type: 285, name_pl: 'm. Świętochłowice', landId: 24, population: 54091, },
  { type: 286, name_pl: 'm. Tychy', landId: 24, population: 129449, },
  { type: 287, name_pl: 'm. Zabrze', landId: 24, population: 187674, },
  { type: 288, name_pl: 'm. Żory', landId: 24, population: 62022, },
  { type: 289, name_pl: 'buski', landId: 26, population: 73127, },
  { type: 290, name_pl: 'jędrzejowski', landId: 26, population: 88665, },
  { type: 291, name_pl: 'kazimierski', landId: 26, population: 35088, },
  { type: 292, name_pl: 'kielecki', landId: 26, population: 201643, },
  { type: 293, name_pl: 'konecki', landId: 26, population: 83005, },
  { type: 294, name_pl: 'opatowski', landId: 26, population: 55471, },
  { type: 295, name_pl: 'ostrowiecki', landId: 26, population: 114670, },
  { type: 296, name_pl: 'pińczowski', landId: 26, population: 41282, },
  { type: 297, name_pl: 'sandomierski', landId: 26, population: 80709, },
  { type: 298, name_pl: 'skarżyski', landId: 26, population: 78400, },
  { type: 299, name_pl: 'starachowicki', landId: 26, population: 93280, },
  { type: 300, name_pl: 'staszowski', landId: 26, population: 73277, },
  { type: 301, name_pl: 'włoszczowski', landId: 26, population: 46668, },
  { type: 302, name_pl: 'm. Kielce', landId: 26, population: 204835, },
  { type: 303, name_pl: 'bartoszycki', landId: 28, population: 60128, },
  { type: 304, name_pl: 'braniewski', landId: 28, population: 42927, },
  { type: 305, name_pl: 'działdowski', landId: 28, population: 65188, },
  { type: 306, name_pl: 'elbląski', landId: 28, population: 56389, },
  { type: 307, name_pl: 'ełcki', landId: 28, population: 86238, },
  { type: 308, name_pl: 'giżycki', landId: 28, population: 56522, },
  { type: 309, name_pl: 'iławski', landId: 28, population: 26642, },
  { type: 310, name_pl: 'kętrzyński', landId: 28, population: 90442, },
  { type: 311, name_pl: 'lidzbarski', landId: 28, population: 64814, },
  { type: 312, name_pl: 'mrągowski', landId: 28, population: 42501, },
  { type: 313, name_pl: 'nidzicki', landId: 28, population: 50169, },
  { type: 314, name_pl: 'nowomiejski', landId: 28, population: 33444, },
  { type: 315, name_pl: 'olecki', landId: 28, population: 43749, },
  { type: 316, name_pl: 'olsztyński', landId: 28, population: 34111, },
  { type: 317, name_pl: 'ostródzki', landId: 28, population: 116766, },
  { type: 318, name_pl: 'piski', landId: 28, population: 104506, },
  { type: 319, name_pl: 'szczycieński', landId: 28, population: 57093, },
  { type: 320, name_pl: 'gołdapski', landId: 28, population: 69286, },
  { type: 321, name_pl: 'węgorzewski', landId: 28, population: 23327, },
  { type: 322, name_pl: 'm. Elbląg', landId: 28, population: 126419, },
  { type: 323, name_pl: 'm. Olsztyn', landId: 28, population: 176457, },
  { type: 324, name_pl: 'chodzieski', landId: 30, population: 47389, },
  { type: 325, name_pl: 'czarnkowsko-trzcianecki', landId: 30, population: 86939, },
  { type: 326, name_pl: 'gnieźnieński', landId: 30, population: 141719, },
  { type: 327, name_pl: 'gostyński', landId: 30, population: 76052, },
  { type: 328, name_pl: 'grodziski', landId: 30, population: 49903, },
  { type: 329, name_pl: 'jarociński', landId: 30, population: 70821, },
  { type: 330, name_pl: 'kaliski', landId: 30, population: 81166, },
  { type: 331, name_pl: 'kępiński', landId: 30, population: 55903, },
  { type: 332, name_pl: 'kolski', landId: 30, population: 88274, },
  { type: 333, name_pl: 'koniński', landId: 30, population: 125965, },
  { type: 334, name_pl: 'kościański', landId: 30, population: 78205, },
  { type: 335, name_pl: 'krotoszyński', landId: 30, population: 77440, },
  { type: 336, name_pl: 'leszczyński', landId: 30, population: 51722, },
  { type: 337, name_pl: 'międzychodzki', landId: 30, population: 36646, },
  { type: 338, name_pl: 'nowotomyski', landId: 30, population: 72725, },
  { type: 339, name_pl: 'obornicki', landId: 30, population: 57042, },
  { type: 340, name_pl: 'ostrowski', landId: 30, population: 159332, },
  { type: 341, name_pl: 'ostrzeszowski', landId: 30, population: 54973, },
  { type: 342, name_pl: 'pilski', landId: 30, population: 137562, },
  { type: 343, name_pl: 'pleszewski', landId: 30, population: 62407, },
  { type: 344, name_pl: 'poznański', landId: 30, population: 319258, },
  { type: 345, name_pl: 'rawicki', landId: 30, population: 59826, },
  { type: 346, name_pl: 'słupecki', landId: 30, population: 58516, },
  { type: 347, name_pl: 'szamotulski', landId: 30, population: 87260, },
  { type: 348, name_pl: 'średzki', landId: 30, population: 55408, },
  { type: 349, name_pl: 'śremski', landId: 30, population: 59307, },
  { type: 350, name_pl: 'turecki', landId: 30, population: 83691, },
  { type: 351, name_pl: 'wągrowiecki', landId: 30, population: 68552, },
  { type: 352, name_pl: 'wolsztyński', landId: 30, population: 55591, },
  { type: 353, name_pl: 'wrzesiński', landId: 30, population: 74856, },
  { type: 354, name_pl: 'złotowski', landId: 30, population: 68737, },
  { type: 355, name_pl: 'm. Kalisz', landId: 30, population: 107019, },
  { type: 356, name_pl: 'm. Konin', landId: 30, population: 79516, },
  { type: 357, name_pl: 'm. Leszno', landId: 30, population: 64338, },
  { type: 358, name_pl: 'm. Poznań', landId: 30, population: 554221, },
  { type: 359, name_pl: 'białogardzki', landId: 32, population: 48261, },
  { type: 360, name_pl: 'choszczeński', landId: 32, population: 49705, },
  { type: 361, name_pl: 'drawski', landId: 32, population: 57485, },
  { type: 362, name_pl: 'goleniowski', landId: 32, population: 79937, },
  { type: 363, name_pl: 'gryficki', landId: 32, population: 60595, },
  { type: 364, name_pl: 'gryfiński', landId: 32, population: 82830, },
  { type: 365, name_pl: 'kamieński', landId: 32, population: 47769, },
  { type: 366, name_pl: 'kołobrzeski', landId: 32, population: 77095, },
  { type: 367, name_pl: 'koszaliński', landId: 32, population: 65049, },
  { type: 368, name_pl: 'myśliborski', landId: 32, population: 67074, },
  { type: 369, name_pl: 'policki', landId: 32, population: 69087, },
  { type: 370, name_pl: 'pyrzycki', landId: 32, population: 39930, },
  { type: 371, name_pl: 'sławieński', landId: 32, population: 57298, },
  { type: 372, name_pl: 'stargardzki', landId: 32, population: 119340, },
  { type: 373, name_pl: 'szczecinecki', landId: 32, population: 77053, },
  { type: 374, name_pl: 'świdwiński', landId: 32, population: 48470, },
  { type: 375, name_pl: 'wałecki', landId: 32, population: 54098, },
  { type: 376, name_pl: 'łobeski', landId: 32, population: 38063, },
  { type: 377, name_pl: 'm. Koszalin', landId: 32, population: 106987, },
  { type: 378, name_pl: 'm. Szczecin', landId: 32, population: 406307, },
  { type: 379, name_pl: 'm. Świnoujście', landId: 32, population: 40765, },
  { type: 380, name_pl: 'm. Wałbrzych', landId: 2, population: 101082, },
];

export const communityDictionary: IMultiformCommunityDictionary<number> = [
  {type: 1, name_pl: 'Czernica', districtId: 23, },
  {type: 2, name_pl: 'Długołęka', districtId: 23, },
  {type: 3, name_pl: 'Kąty Wrocławskie', districtId: 23, },
  {type: 4, name_pl: 'Kobierzyce', districtId: 23, },
  {type: 5, name_pl: 'Miękinia', districtId: 18, },
  {type: 6, name_pl: 'Oborniki Śląskie', districtId: 20, },
  {type: 7, name_pl: 'Siechnice', districtId: 23, },
  {type: 8, name_pl: 'Białe Błota', districtId: 32, },
  {type: 9, name_pl: 'Dąbrowa Chełmińska', districtId: 32, },
  {type: 10, name_pl: 'Dobrocz', districtId: 32, },
  {type: 11, name_pl: 'Koronowo', districtId: 32, },
  {type: 12, name_pl: 'Nowa Wieś Wielka', districtId: 32, },
  {type: 13, name_pl: 'Osielsko', districtId: 32, },
  {type: 14, name_pl: 'Sicienko', districtId: 32, },
  {type: 15, name_pl: 'Solec Kujawski', districtId: 32, },
  {type: 17, name_pl: 'Lubicz', districtId: 44, },
  {type: 18, name_pl: 'Łysomice', districtId: 44, },
  {type: 19, name_pl: 'Wielka Nieszawka', districtId: 44, },
  {type: 20, name_pl: 'Zławieś Wielka', districtId: 44, },
  {type: 21, name_pl: 'Głusk', districtId: 61, },
  {type: 22, name_pl: 'Jastków', districtId: 61, },
  {type: 23, name_pl: 'Konopnica', districtId: 61, },
  {type: 24, name_pl: 'Niedrzwica Duża', districtId: 61, },
  {type: 25, name_pl: 'Niemce', districtId: 61, },
  {type: 26, name_pl: 'Strzyżewice', districtId: 61, },
  {type: 27, name_pl: 'Świdnik', districtId: 69, },
  {type: 28, name_pl: 'Wólka', districtId: 61, },
  {type: 29, name_pl: 'Bogdaniec', districtId: 77, },
  {type: 30, name_pl: 'Deszczno', districtId: 77, },
  {type: 31, name_pl: 'Kłodawa', districtId: 77, },
  {type: 32, name_pl: 'Lubiszyn', districtId: 77, },
  {type: 33, name_pl: 'Santok', districtId: 77, },
  {type: 34, name_pl: 'Świdnica', districtId: 85, },
  {type: 35, name_pl: 'Zielona Góra', districtId: 85, },
  {type: 36, name_pl: 'Aleksandrów Łódzki', districtId: 110, },
  {type: 37, name_pl: 'Andrespol', districtId: 96, },
  {type: 38, name_pl: 'Brójce', districtId: 96, },
  {type: 39, name_pl: 'Konstantynów Łódzki', districtId: 98, },
  {type: 41, name_pl: 'Ksawerów', districtId: 98, },
  {type: 42, name_pl: 'Nowosolna', districtId: 96, },
  {type: 43, name_pl: 'Pabianice', districtId: 98, },
  {type: 44, name_pl: 'Rzgów', districtId: 96, },
  {type: 45, name_pl: 'Stryków', districtId: 110, },
  {type: 46, name_pl: 'Zgierz', districtId: 110, },
  {type: 47, name_pl: 'Igołomia-Wawrzeńczyce', districtId: 120, },
  {type: 48, name_pl: 'Liszki', districtId: 120, },
  {type: 49, name_pl: 'Kocmyrzów-Luborzyca', districtId: 120, },
  {type: 50, name_pl: 'Koniusza', districtId: 128, },
  {type: 51, name_pl: 'Michałowice', districtId: 120, },
  {type: 52, name_pl: 'Mogilany', districtId: 120, },
  {type: 53, name_pl: 'Niepołomice', districtId: 133, },
  {type: 54, name_pl: 'Skawina', districtId: 120, },
  {type: 55, name_pl: 'Świątniki Górne', districtId: 120, },
  {type: 56, name_pl: 'Wieliczka', districtId: 133, },
  {type: 57, name_pl: 'Wielka Wieś', districtId: 120, },
  {type: 58, name_pl: 'Zabierzów', districtId: 120, },
  {type: 59, name_pl: 'Zielonki', districtId: 120, },
  {type: 60, name_pl: 'Izabelin', districtId: 167, },
  {type: 61, name_pl: 'Jabłonna', districtId: 144, },
  {type: 62, name_pl: 'Józefów', districtId: 153, },
  {type: 63, name_pl: 'Konstancin-Jeziorna', districtId: 154, },
  {type: 64, name_pl: 'Lesznowola', districtId: 154, },
  {type: 65, name_pl: 'Łomianki', districtId: 167, },
  {type: 66, name_pl: 'Marki', districtId: 169, },
  {type: 67, name_pl: 'Michałowice', districtId: 157, },
  {type: 68, name_pl: 'Nieporęt', districtId: 144, },
  {type: 69, name_pl: 'Ożarów Mazowiecki', districtId: 167, },
  {type: 70, name_pl: 'Piaseczno', districtId: 154, },
  {type: 71, name_pl: 'Piastów', districtId: 157, },
  {type: 72, name_pl: 'Raszyn', districtId: 157, },
  {type: 73, name_pl: 'Stare Babice', districtId: 167, },
  {type: 74, name_pl: 'Sulejówek', districtId: 148, },
  {type: 75, name_pl: 'Wiązowna', districtId: 153, },
  {type: 76, name_pl: 'Ząbki', districtId: 169, },
  {type: 77, name_pl: 'Zielonka', districtId: 169, },
  {type: 78, name_pl: 'Chrząstowice', districtId: 187, },
  {type: 79, name_pl: 'Dąbrowa', districtId: 187, },
  {type: 80, name_pl: 'Dobrzeń Wielki', districtId: 187, },
  {type: 81, name_pl: 'Komprachcice', districtId: 187, },
  {type: 82, name_pl: 'Łubniany', districtId: 187, },
  {type: 83, name_pl: 'Prószków', districtId: 187, },
  {type: 84, name_pl: 'Tarnów Opolski', districtId: 187, },
  {type: 85, name_pl: 'Turawa', districtId: 187, },
  {type: 86, name_pl: 'Boguchwała', districtId: 206, },
  {type: 87, name_pl: 'Chmielnik', districtId: 206, },
  {type: 88, name_pl: 'Głogów Małopolski', districtId: 206, },
  {type: 89, name_pl: 'Krasne', districtId: 206, },
  {type: 90, name_pl: 'Lubenia', districtId: 206, },
  {type: 91, name_pl: 'Świlcza', districtId: 206, },
  {type: 92, name_pl: 'Trzebownisko', districtId: 206, },
  {type: 93, name_pl: 'Tyczyn', districtId: 206, },
  {type: 94, name_pl: 'Choroszcz', districtId: 217, },
  {type: 95, name_pl: 'Dobrzyniewo Duże', districtId: 217, },
  {type: 96, name_pl: 'Juchnowiec Kościelny', districtId: 217, },
  {type: 97, name_pl: 'Supraśl', districtId: 217, },
  {type: 98, name_pl: 'Wasilków', districtId: 217, },
  {type: 99, name_pl: 'Zabłudów', districtId: 217, },
  {type: 100, name_pl: 'Cedry Wielkie', districtId: 236, },
  {type: 101, name_pl: 'Gdynia', districtId: 250, },
  {type: 102, name_pl: 'Kolbudy', districtId: 236, },
  {type: 103, name_pl: 'Pruszcz Gdański', districtId: 236, },
  {type: 104, name_pl: 'Sopot', districtId: 252, },
  {type: 105, name_pl: 'Stegna', districtId: 242, },
  {type: 106, name_pl: 'Żukowo', districtId: 237, },
  {type: 107, name_pl: 'Chorzów', districtId: 272, },
  {type: 108, name_pl: 'Czeladź', districtId: 253, },
  {type: 109, name_pl: 'Lędziny', districtId: 266, },
  {type: 110, name_pl: 'Mikołów', districtId: 260, },
  {type: 111, name_pl: 'Mysłowice', districtId: 279, },
  {type: 112, name_pl: 'Siemianowice Śląskie', districtId: 283, },
  {type: 113, name_pl: 'Sosnowiec', districtId: 284, },
  {type: 114, name_pl: 'Ruda Śląska', districtId: 281, },
  {type: 115, name_pl: 'Tychy', districtId: 286, },
  {type: 116, name_pl: 'Daleszyce', districtId: 292, },
  {type: 117, name_pl: 'Górno', districtId: 292, },
  {type: 118, name_pl: 'Masłów', districtId: 292, },
  {type: 119, name_pl: 'Miedziana Góra', districtId: 292, },
  {type: 120, name_pl: 'Morawica', districtId: 292, },
  {type: 121, name_pl: 'Piekoszów', districtId: 292, },
  {type: 122, name_pl: 'Sitkówka-Nowiny', districtId: 292, },
  {type: 123, name_pl: 'Barczewo', districtId: 316, },
  {type: 124, name_pl: 'Dywity', districtId: 316, },
  {type: 125, name_pl: 'Gietrzwałd', districtId: 316, },
  {type: 126, name_pl: 'Jonkowo', districtId: 316, },
  {type: 127, name_pl: 'Purda', districtId: 316, },
  {type: 128, name_pl: 'Stawigud', districtId: 316, },
  {type: 129, name_pl: 'Czerwonak', districtId: 344, },
  {type: 130, name_pl: 'Dopiewo', districtId: 344, },
  {type: 131, name_pl: 'Kleszczewo', districtId: 344, },
  {type: 132, name_pl: 'Komorniki', districtId: 344, },
  {type: 133, name_pl: 'Kórnik', districtId: 344, },
  {type: 134, name_pl: 'Luboń', districtId: 344, },
  {type: 135, name_pl: 'Mosina', districtId: 344, },
  {type: 136, name_pl: 'Rokietnica', districtId: 344, },
  {type: 137, name_pl: 'Suchy Las', districtId: 344, },
  {type: 138, name_pl: 'Swarzędz', districtId: 344, },
  {type: 139, name_pl: 'Tarnowo Podgórne', districtId: 344, },
  {type: 140, name_pl: 'Dobra (Szczecińska)', districtId: 369, },
  {type: 141, name_pl: 'Goleniów', districtId: 362, },
  {type: 142, name_pl: 'Gryfino', districtId: 364, },
  {type: 143, name_pl: 'Kobylanka', districtId: 372, },
  {type: 144, name_pl: 'Kołbaskowo', districtId: 369, },
  {type: 145, name_pl: 'Police', districtId: 369, },
  {type: 146, name_pl: 'Stare Czarnowo', districtId: 364, },
];

export const allRiskSantander: IMultiformDictionary<number> = [
  {type: 1, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W1`, },
  {type: 2, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W2`, },
  {type: 3, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W3`, },
  {type: 4, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W4`, },
  {type: 5, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W5`, },
  {type: 6, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W6`, },
  {type: 7, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W7`, },
  {type: 8, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W8`, },
  {type: 9, name_pl: `${I18NGetter().useAllRiskSantander.PACKAGE} W9`, },
];

export const paymentTypeIng: IMultiformDictionary<string> = [
  {type: 'accountWillBeCreated', name_pl: I18NGetter().usePaymentTypeIng.ACCOUNT_WILL_BE_CREATED, },
  {type: 'paymentOnTechnical', name_pl: I18NGetter().usePaymentTypeIng.PAYMENT_ON_TECHNICAL, },
  {type: 'ror', name_pl: I18NGetter().usePaymentTypeIng.ROR, },
];

export const offerNameIng: IMultiformDictionary<string> = [
  {type: 'easyStart', name_pl: I18NGetter().useOfferNameIng.EASY_START, },
  {type: 'easyInstallment', name_pl: I18NGetter().useOfferNameIng.EASY_INSTALLMENT, },
  {type: 'special', name_pl: I18NGetter().useOfferNameIng.SPECIAL, },
];

export const offerTypeIng: IMultiformDictionary<string> = [
  {type: 'easyStart', name_pl: I18NGetter().useOfferNameIng.EASY_START, },
  {type: 'easyInstallment', name_pl: I18NGetter().useOfferNameIng.EASY_INSTALLMENT, },
  {type: 'standard', name_pl: I18NGetter().useOfferNameIng.STANDARD, },
];

export const lifeInsuranceIng: IMultiformDictionary<string> = [
  {type: 'lifePlusNN', name_pl: I18NGetter().useLifeInsuranceIng.LIFE_PLUS_NN, },
  {type: 'standardPlusNN1', name_pl: I18NGetter().useLifeInsuranceIng.STANDARD_PLUS_NN_1, },
  {type: 'standardPlusNN2', name_pl: I18NGetter().useLifeInsuranceIng.STANDARD_PLUS_NN_2, },
  {type: 'lifePlusAviva', name_pl: I18NGetter().useLifeInsuranceIng.LIFE_PLUS_AVIVA, },
  {type: 'standardPlusAviva1', name_pl: I18NGetter().useLifeInsuranceIng.STANDARD_PLUS_AVIVA_1, },
  {type: 'standardPlusAviva2', name_pl: I18NGetter().useLifeInsuranceIng.STANDARD_PLUS_AVIVA_2, },
];

export const realEstateInsuranceIng: IMultiformDictionary<string> = [
  {type: 'standardRealEstateInsurances', name_pl: I18NGetter().useRealEstateInsuranceIng.STANDARD_REAL_ESTATE_INSURANCES, },
  {type: 'extendedRealEstateInsurances', name_pl: I18NGetter().useRealEstateInsuranceIng.EXTENDED_REAL_ESTATE_INSURANCES, },
];

export const finishingStandardIng: IMultiformDictionary<string> = [
  {type: 'high', name_pl: I18NGetter().useFinishingStandardIng.HIGH, },
  {type: 'medium', name_pl: I18NGetter().useFinishingStandardIng.MEDIUM, },
  {type: 'low', name_pl: I18NGetter().useFinishingStandardIng.LOW, },
  {type: 'developerState', name_pl: I18NGetter().useFinishingStandardIng.DEVELOPER_STATE, },
  {type: 'forRenovation', name_pl: I18NGetter().useFinishingStandardIng.FOR_RENOVATION, },
  {type: 'forFinishing', name_pl: I18NGetter().useFinishingStandardIng.FOR_FINISHING, },
  {type: 'underKey', name_pl: I18NGetter().useFinishingStandardIng.UNDER_KEY, },
];

export const productPKOBP: IMultiformDictionary<string> = [
  {type: 'creditStandard', name_pl: I18NGetter().useProductPKOBP.CREDIT_STANDARD, },
  {type: 'creditMIX', name_pl: I18NGetter().useProductPKOBP.CREDIT_MIX, },
  {type: 'mortgageLoan', name_pl: I18NGetter().useProductPKOBP.MORTGAGE_LOAN, },
];

export const rorIncomesPKOBP: IMultiformDictionary<string> = [
  {type: '', name_pl: I18NGetter().useRorIncomesPKOBP.NO_DEC, },
  {type: '3000', name_pl: I18NGetter().useRorIncomesPKOBP.THREE, },
];

export const interestRateFixed: IMultiformDictionary<boolean> = [
  {type: true, name_pl: I18NGetter().useInterestRateFixed.FIXED,},
  {type: false, name_pl: I18NGetter().useInterestRateFixed.VARIABLE,},
];

export const accountTypePKOBP: IMultiformDictionary<string> = [
  {type: '', name_pl: I18NGetter().useAccountTypePKOBP.NONE, },
  {type: 'onlyROR', name_pl: I18NGetter().useAccountTypePKOBP.ONLY_ROR, },
  {type: 'technical', name_pl: I18NGetter().useAccountTypePKOBP.TECHNICAL, },
];

export const provisionTypeAlior: IMultiformDictionary<string> = [
  {type: 'credited', name_pl: I18NGetter().useProvistionTypeAlior.CREDITED, },
  {type: 'cash', name_pl: I18NGetter().useProvistionTypeAlior.CASH, },
];

export const driveroadTypePKOBP: IMultiformDictionary<string> = [
  {type: 'public', name_pl: I18NGetter().useDriveroadTypePKOBP.PUBLIC, },
  {type: 'assets', name_pl: I18NGetter().useDriveroadTypePKOBP.ASSETS, },
  {type: 'roadEasement', name_pl: I18NGetter().useDriveroadTypePKOBP.ROAD_EASEMENT, },
];

export const lowerMarginTypeMillennium: IMultiformDictionary<string> = [
  {type: '', name_pl: I18NGetter().useLowerMarginTypeMillenium.NONE, },
  {type: '03pp', name_pl: I18NGetter().useLowerMarginTypeMillenium.MARGIN_THREE, },
  {type: '05pp', name_pl: I18NGetter().useLowerMarginTypeMillenium.MARGIN_FIVE, },
];

export const provisionTypePekaoBh: IMultiformDictionary<string> = [
  {type: 'credited', name_pl: I18NGetter().useProvisionTypePekaoBh.CREDITED, },
  {type: 'cash', name_pl: I18NGetter().useProvisionTypePekaoBh.CASH, },
];

export const offerTypeEurobank: IMultiformDictionary<string> = [
  {type: 'smallPercentage', name_pl: I18NGetter().useOfferTypeEurobank.SMALL_PERCENTAGE, },
  {type: 'promotion', name_pl: I18NGetter().useOfferTypeEurobank.PROMOTION, },
];

export const accountTypeEurobank: IMultiformDictionary<string> = [
  {type: 'full', name_pl: I18NGetter().useAccountTypeEurobank.FULL, },
  {type: 'prestige', name_pl: I18NGetter().useAccountTypeEurobank.PRESTIGE, },
  {type: 'active', name_pl: I18NGetter().useAccountTypeEurobank.ACTIVE, },
  {type: 'daily', name_pl: I18NGetter().useAccountTypeEurobank.DAILY, },
  {type: 'technical', name_pl: I18NGetter().useAccountTypeEurobank.TECHNICAL, },
];
export const lifeInsurancePeriodTimeEurobank: IMultiformDictionary<string> = [
  {type: '1month', name_pl: I18NGetter().useLifeInsurancePeriodTimeEurobank.MONTH, },
  {type: '1year', name_pl: I18NGetter().useLifeInsurancePeriodTimeEurobank.YEAR, },
  {type: '5years', name_pl: I18NGetter().useLifeInsurancePeriodTimeEurobank.YEARS, },
];

export const lostIncomePeriodTimeEurobank: IMultiformDictionary<string> = [
  {type: '1year', name_pl: I18NGetter().useLostIncomePeriodTimeEurobank.ONE, },
  {type: '3years', name_pl: I18NGetter().useLostIncomePeriodTimeEurobank.THREE, },
  {type: '5years', name_pl: I18NGetter().useLostIncomePeriodTimeEurobank.FIVE, },
];

export const accountVariantsEurobank: IMultiformDictionary<string> = [
  {type: 'full', name_pl: I18NGetter().useAccountVariantsEurobank.FULL, },
  {type: 'technical', name_pl: I18NGetter().useAccountVariantsEurobank.TECHNICAL, },
];

export const withdrawCreditType: IMultiformDictionary<string> = [
  {type: 'cash', name_pl: I18NGetter().useWithdrawCreditType.CASH, },
  {type: 'ownAccount', name_pl: I18NGetter().useWithdrawCreditType.OWN_ACCOUNT, },
  {type: 'otherAccount', name_pl: I18NGetter().useWithdrawCreditType.OTHER_ACCOUNT, },
];

export const sendingExtractType: IMultiformDictionary<string> = [
  {type: 'email', name_pl: I18NGetter().useSendingExtractType.EMAIL, },
  {type: 'extract', name_pl: I18NGetter().useSendingExtractType.EXTRACT, },
];
export const raiffeisenLoanPurposes = [
  {type: 'REGULAR_HOUSEHOLD_EXPENSES', name_pl: 'Bieżące wydatki gospodarstwa',},
  {type: 'OTHER_LOAN_REPAYMENT', name_pl: 'Spłata innych kredytów lub pożyczek',},
  {type: 'MEDICINE_AND_HEALTHCARE', name_pl: 'Zdrowie i leki',},
  {type: 'HOME', name_pl: 'Wydatki na dom / mieszkanie',},
  {type: 'TRAVEL', name_pl: 'Podróż',},
  {type: 'CAR', name_pl: 'Samochód',},
  {type: 'OTHER', name_pl: 'Inne',},
];
export const fFLoanPurposes: IMultiformDictionary<LoanPurposeActivity> = [
  {type: LoanPurposeActivity.BUYING, name_pl: I18NGetter().SimulationLoanPurposeActivity.Buying,},
  {type: LoanPurposeActivity.BUILDING, name_pl: I18NGetter().SimulationLoanPurposeActivity.Building,},
  {type: LoanPurposeActivity.RENOVATING, name_pl: I18NGetter().SimulationLoanPurposeActivity.Renovating,},
  {type: LoanPurposeActivity.ADAPTATION, name_pl: I18NGetter().SimulationLoanPurposeActivity.Adaptation,},
  {type: LoanPurposeActivity.LOAN, name_pl: I18NGetter().SimulationLoanPurposeActivity.Loan,},
  {
    type: LoanPurposeActivity.BUYING_AND_RENOVATING,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.BuyingAndRenovating,
  },
  {
    type: LoanPurposeActivity.BUYING_PLOT_AND_BUILDING,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.BuyingPlotAndBuilding,
  },
  {
    type: LoanPurposeActivity.REFINANCING_RESIDENTIAL_REAL_ESTATE,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.RefinancingResidentialRealEstate,
  },
  {
    type: LoanPurposeActivity.REFINANCING_NONRESIDENTIAL_REAL_ESTATE,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.RefinancingNonresidentialRealEstate,
  },
  {
    type: LoanPurposeActivity.REFINANCING_REAL_ESTATE_LOAN,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.RefinancingRealEstateLoan,
  },
  {
    type: LoanPurposeActivity.REFINANCING_NON_REAL_ESTATE_LOAN,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.RefinancingNonRealEstateLoan,
  },
  {
    type: LoanPurposeActivity.HOME_DEBT_CONSOLIDATION_LOAN,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.HomeDebtConsolidationLoan,
  },
  {
    type: LoanPurposeActivity.CONSUMER_DEBT_CONSOLIDATION_LOAN,
    name_pl: I18NGetter().SimulationLoanPurposeActivity.ConsumerDebtConsolidationLoan,
  },
].filter(x => appDomainConfig.calculator.availableLoanPurposes.includes(x.type));

export const fFCollaterals: IMultiformDictionary<LoanPurposeWhat> = [
  {
    name_pl: I18NGetter().usefFCollaterals.APARTMENT,
    type: LoanPurposeWhat.APARTMENT,
  }, {
    name_pl: I18NGetter().usefFCollaterals.HOUSE,
    type: LoanPurposeWhat.HOUSE,
  }, {
    name_pl: I18NGetter().usefFCollaterals.OFFICE,
    type: LoanPurposeWhat.OFFICE,
  }, {
    name_pl: I18NGetter().usefFCollaterals.BUILDING_PLOT,
    type: LoanPurposeWhat.BUILDING_PLOT,
  }, {
    name_pl: I18NGetter().usefFCollaterals.BUILDING_PLOT_AND_HOUSE,
    type: LoanPurposeWhat.BUILDING_PLOT_AND_HOUSE,
  }, {
    name_pl: I18NGetter().usefFCollaterals.BUILDING_PLOT_AND_CONSTRUCTION,
    type: LoanPurposeWhat.BUILDING_PLOT_AND_CONSTRUCTION,
  }, {
    name_pl: I18NGetter().usefFCollaterals.RECREATION_PLOT,
    type: LoanPurposeWhat.RECREATION_PLOT,
  }, {
    name_pl: I18NGetter().usefFCollaterals.AGRICULTURAL_PLOT,
    type: LoanPurposeWhat.AGRICULTURAL_PLOT,
  }, {
    name_pl: I18NGetter().usefFCollaterals.HOLIDAY_HOME,
    type: LoanPurposeWhat.HOLIDAY_HOME,
  },
].filter(item => !appDomainConfig.excludedMultiformItems.fFCollaterals?.includes(item.type));

export const organisationsDictionary: IMultiformDictionary<OrganisationId> = [
  {type: OrganisationId.LENDI, name_pl: 'Lendi', },
  {type: OrganisationId.FINAMAX, name_pl: 'Finamax', },
  {type: OrganisationId.BANCOVO, name_pl: 'Bancovo', },
];

export const partnerTypeDictionary: IMultiformDictionary<PartnerType> = [
  {type: PartnerType.REAL_ESTATE_OFFICE, name_pl: I18NGetter().usePartnersTypeDictionary.REAL_ESTATE_OFFICE,},
  {type: PartnerType.DEVELOPER, name_pl: I18NGetter().usePartnersTypeDictionary.DEVELOPER,},
  {type: PartnerType.REAL_ESTATE_OFFICE_ORGANISATION, name_pl: I18NGetter().usePartnersTypeDictionary.REAL_ESTATE_OFFICE_ORGANISATION,},
  {type: PartnerType.DEVELOPER_ORGANISATION, name_pl: I18NGetter().usePartnersTypeDictionary.DEVELOPER_ORGANISATION,},
  {type: PartnerType.OWN_PARTNER_CONTRACT, name_pl: I18NGetter().usePartnersTypeDictionary.OWN_PARTNER_CONTRACT,},
  {type: PartnerType.INTERNET_WEBSITE, name_pl: I18NGetter().usePartnersTypeDictionary.INTERNET_WEBSITE,},
  {type: PartnerType.OTHER, name_pl: I18NGetter().usePartnersTypeDictionary.OTHER,},
].filter((partnerType) => !appDomainConfig.excludedPartners.includes(partnerType.type));

export const installmentTypeDictionary: IMultiformDictionary<boolean> = [
  {type: true, name_pl: I18NGetter().useMultiformDictionaries.FIXED_INSTALLMENTS,},
  {type: false, name_pl: I18NGetter().useMultiformDictionaries.DESCENDING_INSTALLMENTS,},
];

export const userRolesDictionary: IMultiformDictionary<RoleTypes> = [
  {type: RoleTypes.ADMIN, name_pl: RoleTypeNames.ADMIN,},
  {type: RoleTypes.COORDINATOR, name_pl: RoleTypeNames.COORDINATOR,},
  {type: RoleTypes.EXPERT, name_pl: RoleTypeNames.EXPERT,},
  {type: RoleTypes.PARTNER, name_pl: RoleTypeNames.PARTNER,},
  {type: RoleTypes.VERIFIER, name_pl: RoleTypeNames.VERIFIER,},
];

export const disabilityStatesDictionary: IMultiformDictionary<DisabilityState> = [
  { name_pl: I18NGetter().useDisabilityStatesDictionary.LIGHT, type: DisabilityState.LIGHT, },
  { name_pl: I18NGetter().useDisabilityStatesDictionary.MODERATE, type: DisabilityState.MODERATE, },
  { name_pl: I18NGetter().useDisabilityStatesDictionary.NOTABLE, type: DisabilityState.NOTABLE, },
];

export const invalidityStatesDictionary: IMultiformDictionary<DisabilityState> = [
  { name_pl: I18NGetter().useInvalidityStatesDictionary.LIGHT, type: DisabilityState.LIGHT, },
  { name_pl: I18NGetter().useInvalidityStatesDictionary.MODERATE, type: DisabilityState.MODERATE, },
  { name_pl: I18NGetter().useInvalidityStatesDictionary.NOTABLE, type: DisabilityState.NOTABLE, },
];

const MultiformDictionary = {
  installmentTypeDictionary,
  partnerTypeDictionary,
  currencyDictionary,
  separationCapitalDictionary,
  civilStatusDictionary,
  educationDictionary,
  homeStatusDictionary,
  liabilitiesDictionary,
  limitsDictionary,
  loanPurposesDictionary,
  incomeTypesDictionary,
  industryDictionary,
  professionDictionary,
  companyTypesDictionary,
  loanPurposeWhatDictionary,
  loanPurposeRightsDictionary,
  estateOwnerTypesDictionary,
  estateConditionDictionary,
  finishingStandardDictionary,
  buildingTypeDictionary,
  constructionTypeDictionary,
  garageCaseDictionary,
  marketTypesDictionary,
  firstOrSubsequentRealEstateDictionary,
  sewersTypeDictionary,
  waterIntakeDictionary,
  personalSharesTypeDictionary,
  personalSharesDictionary,
  assetTypesDictionary,
  incomeDeliveredOnDictionary,
  countriesDictionary: [
    defaultCountry,
    ...countriesDictionary,
  ],
  ekwDictionary,
  borrowersRelationshipsDictionary,
  militaryServiceStatusDictionary,
  documentTypesDictionary,
  landDictionary,
  districtDictionary,
  communityDictionary,
  allRiskSantander,
  paymentTypeIng,
  offerNameIng,
  offerTypeIng,
  lifeInsuranceIng,
  realEstateInsuranceIng,
  finishingStandardIng,
  productPKOBP,
  rorIncomesPKOBP,
  accountTypePKOBP,
  driveroadTypePKOBP,
  interestRateFixed,
  provisionTypeAlior,
  lowerMarginTypeMillennium,
  provisionTypePekaoBh,
  offerTypeEurobank,
  accountTypeEurobank,
  lifeInsurancePeriodTimeEurobank,
  lostIncomePeriodTimeEurobank,
  accountVariantsEurobank,
  withdrawCreditType,
  sendingExtractType,
  contractIncomeTypes,
  otherContractIncomeTypes,
  businessIncomeTypes,
  abroadIncomeTypes,
  retirementIncomeTypes,
  otherIncomeTypes,
  nonBusinessIncomeTypesDictionary,
  allIncomeTypesDictionary,
  ffCivilStatusDictionary,
  genderDictionary,
  financeProfessions,
  otherProfessions,
  trustedProfessions,
  administrationProfessions,
  fFCollaterals,
  fFLoanPurposes,
  taxTypesDictionary,
  incomeTypesByFormType,
  userRolesDictionary,
  raiffeisenLoanPurposes,
  getDistrictsByLandId: (landId?: number) => landId
    ? districtDictionary.filter(district => district.landId === landId)
    : [],
  districtHasCommunity: (districtId?: number) => districtId
    ? communityDictionary.some(community => community.districtId === districtId)
    : false,
};

export function getCommunityByDistrictId(districtId?: number) {
  return districtId
    ? (MultiformDictionary.districtHasCommunity(districtId)
      ? communityDictionary
        .filter(community => community.districtId === districtId)
      : districtDictionary
        .filter(district => district.type === districtId)
        .map(function(v) {
          return {type: -1, name_pl: v.name_pl, districtId: v.type, };
        })) : [];
}

export default MultiformDictionary;

type MultiformDictionaryElementKey = string | number | boolean;

type DictionaryKey = keyof typeof MultiformDictionary;

export function getByType(dictionaryKey: DictionaryKey, type: MultiformDictionaryElementKey): string {
  const dictionary = MultiformDictionary[dictionaryKey] as IMultiformDictionary<MultiformDictionaryElementKey>
    | IMultiformNationalityDictionary<MultiformDictionaryElementKey>;
  const foundObject = dictionary.find((el) => el.type === type);
  return foundObject ? foundObject.name_pl : '';
}
